function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/*! For license information please see index.js.LICENSE.txt */
!function () {
  "use strict";

  var e = {
      931: function _(e, t, n) {
        var r = n(601),
          a = n.n(r),
          i = n(314),
          o = n.n(i)()(a());
        o.push([e.id, ".SpendingSettings{display:flex;flex-direction:column;gap:40px;line-height:1.4em;letter-spacing:0}.SpendingSettings .react-toggle{display:inline-block;position:relative;cursor:pointer;background-color:rgba(0,0,0,0);border:0;padding:0;margin-right:20px;margin-bottom:-8px;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-tap-highlight-color:rgba(0,0,0,0)}.SpendingSettings .react-toggle .read-only{cursor:initial}.SpendingSettings .react-toggle.react-toggle--disabled:hover .react-toggle-track{background-color:#828282 !important}.SpendingSettings .react-toggle--disabled .react-toggle-track{background-color:#828282 !important}.SpendingSettings .react-toggle-screenreader-only{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.SpendingSettings .react-toggle-track{width:104px;height:25px;padding:0;border-radius:30px;-webkit-transition:all .2s ease;-moz-transition:all .2s ease;transition:all .2s ease}.SpendingSettings .react-toggle-track-block{position:absolute;top:12px;margin-top:auto;margin-bottom:auto;line-height:0;left:20px;opacity:0;-webkit-transition:opacity .25s ease;-moz-transition:opacity .25s ease;transition:opacity .25s ease;color:#fff;font-weight:700;text-transform:uppercase;visibility:hidden}.SpendingSettings .react-toggle-track-block.read-only{left:14px}.SpendingSettings .react-toggle--checked .react-toggle-track-block{opacity:1;-webkit-transition:opacity .25s ease;-moz-transition:opacity .25s ease;transition:opacity .25s ease;visibility:visible}.SpendingSettings .react-toggle-track-allow{position:absolute;top:12px;left:30px;margin-top:auto;margin-bottom:auto;line-height:0;opacity:1;text-align:right;-webkit-transition:opacity .25s ease;-moz-transition:opacity .25s ease;transition:opacity .25s ease;color:#fff;font-weight:700;text-transform:uppercase;visibility:visible}.SpendingSettings .react-toggle-track-allow.read-only{left:14px}.SpendingSettings .react-toggle--checked .react-toggle-track-allow{opacity:0;-webkit-transition:opacity .25s ease;-moz-transition:opacity .25s ease;transition:opacity .25s ease;visibility:hidden}.SpendingSettings .react-toggle-thumb{transition:all .5s cubic-bezier(0.23, 1, 0.32, 1) 0ms;position:absolute;top:1px;left:1px;width:23px;height:23px;border:1px solid #4d4d4d;border-radius:50%;background-color:#fafafa;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;-webkit-transition:all .25s ease;-moz-transition:all .25s ease;transition:all .25s ease}.SpendingSettings .react-toggle--checked .react-toggle-thumb{left:80px;border-color:#4d4d4d}.SpendingSettings .react-toggle--focus .react-toggle-thumb{-webkit-box-shadow:0px 0px 3px 2px rgba(0,0,0,.2);-moz-box-shadow:0px 0px 3px 2px rgba(0,0,0,.2);box-shadow:0px 0px 2px 3px rgba(0,0,0,.2)}.SpendingSettings .react-toggle:active .react-toggle-thumb{-webkit-box-shadow:0px 0px 5px 5px rgba(0,0,0,.2);-moz-box-shadow:0px 0px 5px 5px rgba(0,0,0,.2);box-shadow:0px 0px 5px 5px rgba(0,0,0,.2)}.SpendingSettings .specific-rule-row{border-bottom:1px solid #e5e5e5;padding:7px 0 10px;min-height:58px}.SpendingSettings .specific-rule-grid-item{border-bottom:1px solid #e5e5e5;border-right:1px solid #e5e5e5;padding:16px 0 16px 16px;min-height:58px}.SpendingSettings .specific-rule-grid-item:last-child{border-bottom:none}.SpendingSettings .specific-rule-grid-item:nth-child(even){border-right:none}@media(max-width: 899px){.SpendingSettings .specific-rule-grid-item{border-right:none;width:100%}}@media(min-width: 900px){.SpendingSettings .specific-rule-grid-item:nth-last-child(2):nth-child(odd){border-bottom:none}}.SpendingSettings .pending-rule{display:inline-block;width:150px;border-radius:30px;background-color:#828282;text-align:center;color:#fff;font-weight:700;text-transform:uppercase}.SpendingSettings hr{border:0;width:100%;height:1px;margin:15px 0px 15px 0px}.SpendingSettings hr.title-hr{margin-top:5px}.SpendingSettings hr.title-table-hr{margin-top:5px;margin-bottom:0px}.SpendingSettings select{height:45px;padding:4px 7px 4px 8px;vertical-align:baseline;color:#222;border-color:#ccc;box-sizing:border-box;line-height:21px;border-radius:4px;background-color:#fff;border:1px solid #ccc;margin:0}.SpendingSettings select:focus,.SpendingSettings select:focus-visible{border-color:#e0e0e0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 3px rgba(0,0,0,.2);-moz-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 3px rgba(0,0,0,.2);box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 3px rgba(0,0,0,.2);color:#222;outline:none}.SpendingSettings .checkbox_textfield{width:60px;margin:0px 0px 0px 5px;text-align:right;font-size:18px !important;vertical-align:baseline}.SpendingSettings .empty-state-box{text-align:center;background-color:#eee;border-radius:6px;padding:10px 0;margin-bottom:20px;font-size:21px;color:#bdbdbd}.SpendingSettings .hidden{display:none}.specific-rule-name{text-transform:capitalize;word-break:break-all;padding-right:30px}", ""]), t.A = o;
      },
      314: function _(e) {
        e.exports = function (e) {
          var t = [];
          return t.toString = function () {
            return this.map(function (t) {
              var n = "",
                r = void 0 !== t[5];
              return t[4] && (n += "@supports (".concat(t[4], ") {")), t[2] && (n += "@media ".concat(t[2], " {")), r && (n += "@layer".concat(t[5].length > 0 ? " ".concat(t[5]) : "", " {")), n += e(t), r && (n += "}"), t[2] && (n += "}"), t[4] && (n += "}"), n;
            }).join("");
          }, t.i = function (e, n, r, a, i) {
            "string" == typeof e && (e = [[null, e, void 0]]);
            var o = {};
            if (r) for (var l = 0; l < this.length; l++) {
              var c = this[l][0];
              null != c && (o[c] = !0);
            }
            for (var u = 0; u < e.length; u++) {
              var s = [].concat(e[u]);
              r && o[s[0]] || (void 0 !== i && (void 0 === s[5] || (s[1] = "@layer".concat(s[5].length > 0 ? " ".concat(s[5]) : "", " {").concat(s[1], "}")), s[5] = i), n && (s[2] ? (s[1] = "@media ".concat(s[2], " {").concat(s[1], "}"), s[2] = n) : s[2] = n), a && (s[4] ? (s[1] = "@supports (".concat(s[4], ") {").concat(s[1], "}"), s[4] = a) : s[4] = "".concat(a)), t.push(s));
            }
          }, t;
        };
      },
      601: function _(e) {
        e.exports = function (e) {
          return e[1];
        };
      },
      72: function _(e) {
        var t = [];
        function n(e) {
          for (var n = -1, r = 0; r < t.length; r++) if (t[r].identifier === e) {
            n = r;
            break;
          }
          return n;
        }
        function r(e, r) {
          for (var i = {}, o = [], l = 0; l < e.length; l++) {
            var c = e[l],
              u = r.base ? c[0] + r.base : c[0],
              s = i[u] || 0,
              d = "".concat(u, " ").concat(s);
            i[u] = s + 1;
            var m = n(d),
              f = {
                css: c[1],
                media: c[2],
                sourceMap: c[3],
                supports: c[4],
                layer: c[5]
              };
            if (-1 !== m) t[m].references++, t[m].updater(f);else {
              var p = a(f, r);
              r.byIndex = l, t.splice(l, 0, {
                identifier: d,
                updater: p,
                references: 1
              });
            }
            o.push(d);
          }
          return o;
        }
        function a(e, t) {
          var n = t.domAPI(t);
          return n.update(e), function (t) {
            if (t) {
              if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap && t.supports === e.supports && t.layer === e.layer) return;
              n.update(e = t);
            } else n.remove();
          };
        }
        e.exports = function (e, a) {
          var i = r(e = e || [], a = a || {});
          return function (e) {
            e = e || [];
            for (var o = 0; o < i.length; o++) {
              var l = n(i[o]);
              t[l].references--;
            }
            for (var c = r(e, a), u = 0; u < i.length; u++) {
              var s = n(i[u]);
              0 === t[s].references && (t[s].updater(), t.splice(s, 1));
            }
            i = c;
          };
        };
      },
      659: function _(e) {
        var t = {};
        e.exports = function (e, n) {
          var r = function (e) {
            if (void 0 === t[e]) {
              var n = document.querySelector(e);
              if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
                n = n.contentDocument.head;
              } catch (e) {
                n = null;
              }
              t[e] = n;
            }
            return t[e];
          }(e);
          if (!r) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
          r.appendChild(n);
        };
      },
      540: function _(e) {
        e.exports = function (e) {
          var t = document.createElement("style");
          return e.setAttributes(t, e.attributes), e.insert(t, e.options), t;
        };
      },
      56: function _(e, t, n) {
        e.exports = function (e) {
          var t = n.nc;
          t && e.setAttribute("nonce", t);
        };
      },
      825: function _(e) {
        e.exports = function (e) {
          if ("undefined" == typeof document) return {
            update: function update() {},
            remove: function remove() {}
          };
          var t = e.insertStyleElement(e);
          return {
            update: function update(n) {
              !function (e, t, n) {
                var r = "";
                n.supports && (r += "@supports (".concat(n.supports, ") {")), n.media && (r += "@media ".concat(n.media, " {"));
                var a = void 0 !== n.layer;
                a && (r += "@layer".concat(n.layer.length > 0 ? " ".concat(n.layer) : "", " {")), r += n.css, a && (r += "}"), n.media && (r += "}"), n.supports && (r += "}");
                var i = n.sourceMap;
                i && "undefined" != typeof btoa && (r += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(i)))), " */")), t.styleTagTransform(r, e, t.options);
              }(t, e, n);
            },
            remove: function remove() {
              !function (e) {
                if (null === e.parentNode) return !1;
                e.parentNode.removeChild(e);
              }(t);
            }
          };
        };
      },
      113: function _(e) {
        e.exports = function (e, t) {
          if (t.styleSheet) t.styleSheet.cssText = e;else {
            for (; t.firstChild;) t.removeChild(t.firstChild);
            t.appendChild(document.createTextNode(e));
          }
        };
      }
    },
    t = {};
  function n(r) {
    var a = t[r];
    if (void 0 !== a) return a.exports;
    var i = t[r] = {
      id: r,
      exports: {}
    };
    return e[r](i, i.exports, n), i.exports;
  }
  n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, {
      a: t
    }), t;
  }, n.d = function (e, t) {
    for (var r in t) n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, {
      enumerable: !0,
      get: t[r]
    });
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.nc = void 0;
  var r = {};
  n.r(r), n.d(r, {
    BlockedTransactions: function BlockedTransactions() {
      return gt;
    },
    SpendingSettings: function SpendingSettings() {
      return Dr;
    },
    default: function _default() {
      return Fr;
    }
  });
  var a = n(72),
    i = n.n(a),
    o = n(825),
    l = n.n(o),
    c = n(659),
    u = n.n(c),
    s = n(56),
    d = n.n(s),
    m = n(540),
    f = n.n(m),
    p = n(113),
    h = n.n(p),
    g = n(931),
    y = {};
  y.styleTagTransform = h(), y.setAttributes = d(), y.insert = u().bind(null, "head"), y.domAPI = l(), y.insertStyleElement = f(), i()(g.A, y), g.A && g.A.locals && g.A.locals;
  var b = require("@mui/material/Box"),
    v = n.n(b),
    E = require("@mui/material/CircularProgress"),
    x = n.n(E),
    S = require("@mui/material/CssBaseline"),
    k = n.n(S),
    w = require("@mui/material/styles"),
    C = require("axios"),
    O = n.n(C),
    A = require("jwt-decode"),
    T = require("react"),
    R = n.n(T),
    j = require("@mui/icons-material/AddCircle"),
    _ = n.n(j),
    q = require("@mui/icons-material/KeyboardArrowDown"),
    I = n.n(q),
    M = require("@mui/icons-material/KeyboardArrowUp"),
    B = n.n(M),
    N = require("@mui/material"),
    P = require("@mui/material/Button"),
    L = n.n(P),
    z = require("@mui/material/Collapse"),
    D = n.n(z),
    F = require("@mui/material/Table"),
    U = n.n(F),
    W = require("@mui/material/TableBody"),
    V = n.n(W),
    H = require("@mui/material/TableCell"),
    G = n.n(H),
    Y = require("@mui/material/TableHead"),
    K = n.n(Y),
    Z = require("@mui/material/TableRow"),
    X = n.n(Z),
    J = require("@mui/material/Typography"),
    Q = n.n(J),
    ee = require("moment-timezone"),
    te = n.n(ee),
    ne = require("prop-types"),
    re = n.n(ne),
    ae = require("@mui/system"),
    ie = require("@mui/utils"),
    oe = {
      primary: "#0D875C",
      secondary: "#0D875C",
      tertiary: "#0070c2",
      alert: "#C94841",
      white: "#FFF",
      accent: "#EFF8EC",
      success: "#4cc15f",
      textColor: "#333",
      grey2: "#4F4F4F"
    },
    le = function le(e) {
      return {
        palette: {
          background: {
            default: e.white
          },
          alert: {
            main: e.alert
          },
          primary: {
            main: e.primary
          },
          secondary: {
            main: e.secondary
          },
          tertiary: {
            main: e.tertiary
          },
          banner: {
            main: e.tertiary,
            contrast: e.white
          }
        },
        shape: {
          borderRadius: 6
        },
        typography: {
          fontFamily: "Calibre",
          fontSize: 18,
          color: e.textColor,
          h1: {
            fontWeight: 600,
            fontSize: "28px",
            lineHeight: 1.2,
            letterSpacing: 0
          },
          h2: {
            fontWeight: 400,
            fontSize: "22px",
            lineHeight: 1.3
          },
          h3: {
            fontWeight: 400,
            fontSize: "22px",
            lineHeight: 1.3
          },
          h4: {
            fontWeight: 400,
            fontSize: "20px",
            lineHeight: 1.3
          },
          h5: {
            fontWeight: 600,
            fontSize: "20px"
          },
          h6: {
            fontSize: "28px"
          },
          body1: {
            fontSize: "18px",
            lineHeight: 1.3
          },
          body2: {
            fontSize: "16px"
          },
          caption: {
            fontSize: "16px",
            color: oe.grey2
          }
        },
        components: {
          MuiButton: {
            styleOverrides: {
              root: {
                textTransform: "capitalize",
                fontWeight: "600"
              }
            }
          },
          MuiTextField: {
            styleOverrides: {
              root: {
                "& input[type=number]": {
                  MozAppearance: "textfield",
                  "&::-webkit-outer-spin-button": {
                    WebkitAppearance: "none",
                    margin: 0
                  },
                  "&::-webkit-inner-spin-button": {
                    WebkitAppearance: "none",
                    margin: 0
                  }
                }
              }
            }
          },
          MuiBox: {
            styleOverrides: {
              root: {
                fontFamily: "Calibre"
              }
            }
          },
          MuiAccordion: {
            styleOverrides: {
              root: {
                boxShadow: "none",
                backgroundColor: e.primary,
                "&.Mui-expanded": {
                  margin: 0,
                  borderTop: "1px solid #d9d9d9"
                },
                "& .MuiAccordionSummary-root": {
                  backgroundColor: e.white,
                  "&:hover": {
                    backgroundColor: e.accent
                  },
                  "&.Mui-expanded": {
                    backgroundColor: e.accent
                  },
                  height: "64px"
                },
                "& .MuiAccordionDetails-root": {
                  backgroundColor: (0, ae.lighten)(e.accent, .7),
                  padding: "0",
                  paddingLeft: "16px"
                }
              }
            }
          },
          MuiSnackbarContent: {
            styleOverrides: {
              root: {
                backgroundColor: oe.success,
                color: "#fff"
              }
            }
          },
          MuiAutocomplete: {
            styleOverrides: {
              root: {
                "& .MuiInputLabel-root": {
                  display: "block !important"
                }
              },
              paper: {
                maxHeight: 320
              }
            }
          },
          MuiDialog: {
            styleOverrides: {
              root: {
                background: "rgba(0, 0, 0, 0.3)"
              }
            }
          },
          MuiDialogTitle: {
            styleOverrides: {
              root: {
                fontWeight: "600"
              }
            }
          },
          MuiDialogContent: {
            styleOverrides: {
              root: {
                borderTop: "1px solid #d9d9d9",
                padding: "24px !important"
              }
            }
          },
          MuiDialogActions: {
            styleOverrides: {
              root: {
                padding: "16px 24px"
              }
            }
          },
          MuiInputLabel: {
            styleOverrides: {
              outlined: {
                display: "none !important"
              }
            }
          },
          MuiInputBase: {
            styleOverrides: {
              root: {
                "& input[type=text]": {
                  fontSize: 18
                }
              }
            }
          },
          MuiTableCell: {
            styleOverrides: {
              head: {
                fontWeight: "bold",
                paddingBottom: "0"
              },
              body: {
                verticalAlign: "top",
                paddingBottom: "8px",
                paddingTop: "8px"
              }
            }
          }
        }
      };
    },
    ce = (0, w.createTheme)(le(oe));
  function ue(e) {
    var t,
      n,
      r,
      a,
      i,
      o,
      l,
      c = {
        primary: (null == e || null === (t = e.palette) || void 0 === t || null === (t = t.primary) || void 0 === t ? void 0 : t.main) || "#0D875C",
        secondary: (null == e || null === (n = e.palette) || void 0 === n || null === (n = n.secondary) || void 0 === n ? void 0 : n.main) || "#0D875C",
        tertiary: (null == e || null === (r = e.palette) || void 0 === r || null === (r = r.tertiary) || void 0 === r ? void 0 : r.main) || "#0070c2",
        alert: (null == e || null === (a = e.palette) || void 0 === a || null === (a = a.alert) || void 0 === a ? void 0 : a.main) || "#C94841",
        white: (null == e || null === (i = e.palette) || void 0 === i || null === (i = i.white) || void 0 === i ? void 0 : i.main) || "#FFF",
        accent: (null == e || null === (o = e.palette) || void 0 === o || null === (o = o.accent) || void 0 === o ? void 0 : o.main) || "#EFF8EC",
        textColor: (null == e || null === (l = e.palette) || void 0 === l || null === (l = l.primary) || void 0 === l ? void 0 : l.textColor) || "#333"
      },
      u = (0, ie.deepmerge)(le(c), e);
    return (0, w.createTheme)(u);
  }
  function se(e) {
    return se = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
      return _typeof(e);
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
    }, se(e);
  }
  function de(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function me(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? de(Object(n), !0).forEach(function (t) {
        fe(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : de(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  function fe(e, t, n) {
    return (t = function (e) {
      var t = function (e, t) {
        if ("object" != se(e) || !e) return e;
        var n = e[Symbol.toPrimitive];
        if (void 0 !== n) {
          var r = n.call(e, "string");
          if ("object" != se(r)) return r;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(e);
      }(e);
      return "symbol" == se(t) ? t : t + "";
    }(t)) in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  function pe(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  function he(e) {
    var t,
      n,
      r = e.merchantSelected,
      a = e.transactions,
      i = (0, N.useMediaQuery)(function (e) {
        return e.breakpoints.up("sm");
      }),
      o = new Date(),
      l = te()(o),
      c = te().tz.guess(l),
      u = te().tz(c).zoneAbbr(),
      s = (t = (0, T.useState)({}), n = 2, function (e) {
        if (Array.isArray(e)) return e;
      }(t) || function (e, t) {
        var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (null != n) {
          var r,
            a,
            i,
            o,
            l = [],
            c = !0,
            u = !1;
          try {
            if (i = (n = n.call(e)).next, 0 === t) {
              if (Object(n) !== n) return;
              c = !1;
            } else for (; !(c = (r = i.call(n)).done) && (l.push(r.value), l.length !== t); c = !0);
          } catch (e) {
            u = !0, a = e;
          } finally {
            try {
              if (!c && null != n.return && (o = n.return(), Object(o) !== o)) return;
            } finally {
              if (u) throw a;
            }
          }
          return l;
        }
      }(t, n) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return pe(e, t);
          var n = {}.toString.call(e).slice(8, -1);
          return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? pe(e, t) : void 0;
        }
      }(t, n) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }()),
      d = s[0],
      m = s[1],
      f = function f(e) {
        return te()(e).format("MMM D");
      },
      p = function p(e) {
        return R().createElement(R().Fragment, null, R().createElement(Q(), null, e.attributes.name), R().createElement(L(), {
          color: "tertiary",
          onClick: function onClick() {
            return r(e);
          },
          size: "small",
          startIcon: R().createElement(_(), null),
          sx: {
            fontSize: "14px"
          }
        }, "Add Merchant Exceptions"));
      },
      h = R().createElement(U(), {
        "aria-label": "simple table"
      }, R().createElement(K(), null, R().createElement(X(), null, R().createElement(G(), {
        sx: {
          width: "9%"
        }
      }, "Date"), R().createElement(G(), {
        sx: {
          width: "10%"
        }
      }, "Time(", u, ")"), R().createElement(G(), {
        sx: {
          width: "28%"
        }
      }, "Merchant"), R().createElement(G(), null, "Location"), R().createElement(G(), null, "Category"), R().createElement(G(), {
        sx: {
          width: "25%"
        }
      }, "Explanation"), R().createElement(G(), null, "Blocked"), R().createElement(G(), {
        align: "right"
      }, "Charged"))), R().createElement(V(), null, a.map(function (e, t) {
        var n, r, a, i;
        return R().createElement(X(), {
          key: "".concat(e.attributes.name, "-").concat(t),
          sx: {
            "&:last-child td, &:last-child th": {
              border: 0
            }
          }
        }, R().createElement(G(), {
          align: "left"
        }, f(e.attributes.timestamp)), R().createElement(G(), {
          align: "left"
        }, (a = e.attributes.timestamp, i = te()(a), a && i.format("h:mm a"))), R().createElement(G(), {
          align: "left"
        }, p(e)), R().createElement(G(), {
          align: "left"
        }, e.attributes.location), R().createElement(G(), {
          align: "left"
        }, e.attributes.humanReadableType), R().createElement(G(), {
          align: "left"
        }, (null === (n = e.attributes.block) || void 0 === n ? void 0 : n.explanation) || "-"), R().createElement(G(), {
          align: "left",
          sx: {
            color: ce.palette.alert.main
          }
        }, "-$", Math.abs(null === (r = e.attributes.amount) || void 0 === r ? void 0 : r.amount)), R().createElement(G(), {
          align: "right"
        }, "$0.00"));
      }))),
      g = function g(e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "#828282",
          r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "left";
        return R().createElement(v(), {
          sx: {
            display: "flex",
            justifyContent: "space-between"
          }
        }, R().createElement(Q(), {
          sx: {
            color: n
          }
        }, e), R().createElement(Q(), {
          align: r
        }, t));
      },
      y = R().createElement(v(), null, R().createElement("hr", {
        style: {
          marginBottom: "32px",
          backgroundColor: "#828282"
        }
      }), a.map(function (e, t) {
        var n, r;
        return R().createElement(v(), {
          key: t,
          sx: {
            display: "flex",
            flexDirection: "column",
            gap: 2,
            mb: 4,
            pb: 2,
            borderBottom: "1px solid #828282"
          }
        }, g("Date", f(e.attributes.timestamp)), R().createElement(v(), {
          sx: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between"
          }
        }, R().createElement(Q(), {
          sx: {
            color: "#828282"
          }
        }, "Merchant"), R().createElement(v(), {
          sx: {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end"
          }
        }, p(e))), g("Charged", "$0.00"), g("Blocked", "-$".concat(Math.abs(null === (n = e.attributes.amount) || void 0 === n ? void 0 : n.amount)), ce.palette.alert.main), R().createElement(D(), {
          in: d[e.id],
          timeout: "auto",
          unmountOnExit: !0
        }, R().createElement(v(), {
          sx: {
            display: "flex",
            flexDirection: "column",
            gap: 2
          }
        }, g("Category", e.attributes.humanReadableType), g("Location", e.attributes.location), g("Explanation", (null === (r = e.attributes.block) || void 0 === r ? void 0 : r.explanation) || "-", "#828282", "right"))), R().createElement(L(), {
          onClick: function onClick() {
            return t = e.id, void m(function (e) {
              return me(me({}, e), {}, fe({}, t, !e[t]));
            });
            var t;
          },
          variant: "text"
        }, d[e.id] ? R().createElement(R().Fragment, null, "See less ", R().createElement(B(), null)) : R().createElement(R().Fragment, null, "See more ", R().createElement(I(), null))));
      }));
    return R().createElement("div", {
      className: "SpendingSettings"
    }, R().createElement(Q(), {
      variant: "h1"
    }, "Blocked Transactions"), R().createElement("div", null, 0 == a.length && R().createElement("div", {
      className: "empty-state-box",
      style: {
        marginTop: "15px"
      }
    }, "No Blocked Transactions"), i ? h : y));
  }
  he.propTypes = {
    transactions: re().array,
    merchantSelected: re().func
  };
  var ge = require("@mui/icons-material/CheckCircle"),
    ye = n.n(ge),
    be = require("@mui/material/Dialog"),
    ve = n.n(be),
    Ee = require("@mui/material/DialogActions"),
    xe = n.n(Ee),
    Se = require("@mui/material/DialogContent"),
    ke = n.n(Se),
    we = require("@mui/material/DialogTitle"),
    Ce = n.n(we),
    Oe = require("formik"),
    Ae = require("yup"),
    Te = require("@mui/icons-material/Delete"),
    Re = n.n(Te),
    je = require("@mui/material/Autocomplete"),
    _e = n.n(je),
    qe = require("@mui/material/Checkbox"),
    Ie = n.n(qe),
    Me = require("@mui/material/FormControl"),
    Be = n.n(Me),
    Ne = require("@mui/material/FormControlLabel"),
    Pe = n.n(Ne),
    Le = require("@mui/material/Radio"),
    ze = n.n(Le),
    De = require("@mui/material/RadioGroup"),
    Fe = n.n(De),
    Ue = require("@mui/material/Stack"),
    We = n.n(Ue),
    Ve = require("@mui/material/TextField"),
    He = n.n(Ve);
  function $e() {
    return $e = Object.assign ? Object.assign.bind() : function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];
        for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
      return e;
    }, $e.apply(null, arguments);
  }
  function Ge(e) {
    var t = e.deleteMerchant,
      n = e.isEdit,
      r = e.merchantClusterOptions,
      a = e.handleChange,
      i = e.setFieldValue,
      o = e.showDeleteButton,
      l = e.values,
      c = R().createElement(Be(), {
        fullWidth: !0,
        size: "medium"
      }, R().createElement(_e(), {
        id: "merchant-cluster",
        isOptionEqualToValue: function isOptionEqualToValue(e, t) {
          return e === t;
        },
        name: "merchant_cluster",
        onChange: function onChange(e, t) {
          i("merchant_cluster", t);
        },
        options: r,
        renderInput: function renderInput(e) {
          return R().createElement(He(), $e({}, e, {
            label: "Search list",
            variant: "outlined"
          }));
        },
        value: l.merchant_cluster || null
      }), R().createElement(Oe.ErrorMessage, {
        component: "p",
        name: "merchant_cluster"
      })),
      u = R().createElement(Pe(), {
        control: R().createElement(Ie(), {
          checked: l.custom_merchant_request,
          color: "primary",
          id: "custom-merchant-request",
          name: "custom_merchant_request",
          onChange: a,
          size: "small",
          value: l.custom_merchant_request
        }),
        label: R().createElement(Q(), {
          variant: "body2"
        }, "The merchant I’m looking for isn’t on the list")
      }),
      s = R().createElement(Q(), {
        variant: "body2"
      }, 'This setting will be applied to any transaction that includes the string of text that you enter in the Merchant Name. For example, if you block “Resale” any merchant that includes “Resale” in their merchant name will be blocked. You can also add merchant settings directly by clicking "Review" next to any transaction on the Transactions tab.'),
      d = R().createElement(Be(), {
        fullWidth: !0,
        size: "medium"
      }, R().createElement(Q(), {
        sx: {
          mb: 1
        },
        variant: "body2"
      }, "Merchant Name"), R().createElement(He(), {
        id: "merchant_name",
        name: "merchant_name",
        onChange: a,
        size: "small",
        type: "text",
        value: l.merchant_name
      })),
      m = R().createElement(Be(), {
        fullWidth: !0,
        size: "small",
        sx: {
          width: "95px"
        }
      }, R().createElement(He(), {
        id: "merchant_limit",
        name: "merchant_limit",
        onChange: a,
        size: "small",
        type: "number",
        value: l.merchant_limit
      })),
      f = R().createElement(Be(), null, R().createElement(Fe(), {
        id: "merchant-settings",
        name: "merchant_settings",
        onChange: a,
        value: l.merchant_settings
      }, R().createElement(Pe(), {
        control: R().createElement(ze(), {
          size: "small"
        }),
        label: R().createElement(Q(), {
          variant: "body2"
        }, "Block all purchases"),
        value: "block_all"
      }), "block_all" === l.merchant_settings && R().createElement(Q(), {
        sx: {
          ml: 4
        },
        variant: "caption"
      }, "This will decline all transactions associated with this merchant."), R().createElement(Pe(), {
        control: R().createElement(ze(), {
          size: "small"
        }),
        label: R().createElement(Q(), {
          variant: "body2"
        }, "Allow all purchases"),
        value: "allow_all"
      }), "allow_all" === l.merchant_settings && R().createElement(Q(), {
        sx: {
          ml: 4,
          maxWidth: "460px",
          mb: 2
        },
        variant: "caption"
      }, "This will override spending limit if you have set one. The cardholder can spend as much as their balance allows."), R().createElement(Pe(), {
        control: R().createElement(ze(), {
          size: "small"
        }),
        label: R().createElement(We(), {
          alignItems: "center",
          direction: "row",
          spacing: 2
        }, R().createElement(Q(), {
          variant: "body2"
        }, "Allow all purchases except above this spending limit $"), m),
        value: "enforce_limit"
      })));
    return R().createElement(We(), {
      spacing: 2
    }, R().createElement(Q(), {
      sx: {
        borderBottom: "1px solid #d9d9d9",
        mb: 3
      },
      variant: "h5"
    }, "Merchant"), !n && R().createElement(R().Fragment, null, c, u, l.custom_merchant_request && R().createElement(R().Fragment, null, s, d)), n && R().createElement(We(), {
      alignItems: "center",
      direction: "row",
      justifyContent: "space-between",
      spacing: 2
    }, R().createElement("div", {
      className: "specific-rule-name"
    }, l.merchant_name), t && o && R().createElement(L(), {
      color: "tertiary",
      onClick: function onClick() {
        return t(l);
      },
      startIcon: R().createElement(Re(), null)
    }, "Delete Merchant")), R().createElement(Q(), {
      sx: {
        borderBottom: "1px solid #d9d9d9",
        mb: 3
      },
      variant: "h5"
    }, "Settings"), f);
  }
  function Ye(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  function Ke(e) {
    var t,
      n,
      r,
      a = e.addMerchantRule,
      i = e.blockedTransactionsException,
      o = e.axios,
      l = e.deleteMerchantRule,
      c = e.editRule,
      u = e.onCancel,
      s = e.merchantAddedSuccess,
      d = "".concat(c ? "Edit" : "Add", " Merchant Setting"),
      m = (n = (0, T.useState)([]), r = 2, function (e) {
        if (Array.isArray(e)) return e;
      }(n) || function (e, t) {
        var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (null != n) {
          var r,
            a,
            i,
            o,
            l = [],
            c = !0,
            u = !1;
          try {
            if (i = (n = n.call(e)).next, 0 === t) {
              if (Object(n) !== n) return;
              c = !1;
            } else for (; !(c = (r = i.call(n)).done) && (l.push(r.value), l.length !== t); c = !0);
          } catch (e) {
            u = !0, a = e;
          } finally {
            try {
              if (!c && null != n.return && (o = n.return(), Object(o) !== o)) return;
            } finally {
              if (u) throw a;
            }
          }
          return l;
        }
      }(n, r) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return Ye(e, t);
          var n = {}.toString.call(e).slice(8, -1);
          return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Ye(e, t) : void 0;
        }
      }(n, r) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }()),
      f = m[0],
      p = m[1],
      h = "/api/v2/merchant_clusters/";
    (0, T.useEffect)(function () {
      o && o.get(h).then(function (e) {
        var t,
          n = null === (t = e.data.data) || void 0 === t ? void 0 : t.map(function (e) {
            return e.id;
          });
        p(n);
      });
    }, [o, h]);
    var g = Ae.object().shape({
        merchant_cluster: Ae.string().when(["custom_merchant_request"], {
          is: function is(e) {
            return !e && !c;
          },
          then: function then() {
            return Ae.string().required("field required");
          },
          otherwise: function otherwise() {
            return Ae.string();
          }
        }),
        custom_merchant_request: Ae.boolean(),
        merchant_name: Ae.string().when("custom_merchant_request", {
          is: !0,
          then: function then() {
            return Ae.string().required("field required");
          },
          otherwise: function otherwise() {
            return Ae.string();
          }
        }),
        merchant_settings: Ae.string().required("field required"),
        merchant_limit: Ae.string().when("merchant_settings", {
          is: "enforce_limit",
          then: function then() {
            return Ae.string().required("field required");
          },
          otherwise: function otherwise() {
            return Ae.string();
          }
        })
      }),
      y = Ae.object().shape({
        merchant_settings: Ae.string().required("field required"),
        merchant_limit: Ae.string().when("merchant_settings", {
          is: "enforce_limit",
          then: function then() {
            return Ae.string().required("field required");
          },
          otherwise: function otherwise() {
            return Ae.string();
          }
        })
      }),
      b = {
        merchant_id: null == c ? void 0 : c.id,
        merchant_cluster: (null == c ? void 0 : c.name) || "",
        custom_merchant_request: !1,
        merchant_name: (null == c ? void 0 : c.name) || "",
        merchant_settings: (null == c ? void 0 : c.action) || "",
        merchant_limit: (null == c || null === (t = c.limit) || void 0 === t ? void 0 : t.amount) || ""
      },
      E = function E(e) {
        if (e) {
          var t = {
            id: e.merchant_id
          };
          l(t), u();
        }
      },
      S = R().createElement(Oe.Formik, {
        initialValues: b,
        onSubmit: function onSubmit(e) {
          if (e) {
            var t = "enforce_limit" == e.merchant_settings ? e.merchant_limit : null,
              n = {
                name: e.merchant_cluster || e.merchant_name,
                action: e.merchant_settings,
                limit: {
                  amount: t,
                  currency: "USD"
                },
                id: e.merchant_id
              };
            a(n);
          }
        },
        validateOnMount: !0,
        validationSchema: c ? y : g
      }, function (e) {
        var t = e.handleChange,
          n = e.handleSubmit,
          r = e.setFieldTouched,
          a = e.setFieldValue,
          o = e.values,
          l = e.isValid;
        return R().createElement(R().Fragment, null, R().createElement(ke(), null, R().createElement(Ge, {
          deleteMerchant: E,
          handleChange: t,
          isEdit: !!c,
          merchantClusterOptions: f,
          setFieldTouched: r,
          setFieldValue: a,
          showDeleteButton: !i,
          values: o
        })), R().createElement(xe(), null, R().createElement(L(), {
          onClick: u,
          variant: "outlined"
        }, "Cancel"), R().createElement(L(), {
          disabled: !l,
          onClick: n,
          variant: "contained"
        }, "Save Settings")));
      }),
      k = R().createElement(v(), {
        sx: {
          textAlign: "center",
          height: 500
        }
      }, R().createElement(x(), {
        color: "success",
        sx: {
          m: 30
        }
      })),
      w = R().createElement("div", null, R().createElement(Ce(), null, d), !f && k, f && S),
      C = R().createElement("div", null, R().createElement(Ce(), null, "Merchant Exception"), S),
      O = R().createElement(v(), {
        sx: {
          textAlign: "center",
          p: 5
        }
      }, R().createElement(ye(), {
        color: "primary",
        fontSize: "large"
      }), R().createElement(Ce(), {
        sx: {
          backgroundColor: "#fff"
        }
      }, "Merchant Settings Saved!"), i && R().createElement(ke(), {
        sx: {
          mb: 2
        }
      }, "You can edit this merchant exception on the Spending Settings Page"), R().createElement(L(), {
        onClick: u,
        sx: {
          width: 240
        },
        variant: "contained"
      }, "Done"));
    return !s && i ? R().createElement(ve(), {
      maxWidth: "sm",
      open: !0
    }, C) : R().createElement(ve(), {
      maxWidth: O ? "xs" : "sm",
      open: !0
    }, !s && w, s && O);
  }
  Ge.propTypes = {
    isEdit: re().bool,
    merchantClusterOptions: re().arrayOf(re().string),
    values: re().object,
    deleteMerchant: re().func,
    handleChange: re().func,
    showDeleteButton: re().bool
  }, Ke.propTypes = {
    addMerchantRule: re().func,
    axios: re().func,
    editRule: re().object,
    deleteMerchantRule: re().func,
    onCancel: re().func.isRequired,
    merchantAddedSuccess: re().bool
  };
  var Ze,
    Xe,
    Je,
    Qe,
    et = require("@emotion/react"),
    tt = require("@mui/material/GlobalStyles"),
    nt = n.n(tt);
  function rt(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
      raw: {
        value: Object.freeze(t)
      }
    }));
  }
  var at = "#0d875c",
    it = "#c94841",
    ot = "18px",
    lt = function lt(e) {
      return (0, et.css)(Ze || (Ze = rt(["\n  body {\n    margin: 0;\n    padding: 0;\n    background-color: ", ";\n    color: ", ";\n  }\n"])), (null == e ? void 0 : e.backgroundColor) || "#fff", (null == e ? void 0 : e.textColor) || "#333");
    },
    ct = function ct(e) {
      return (0, et.css)(Xe || (Xe = rt(["\n  .SpendingSettings {\n    max-width: ", ";\n    padding: ", ";\n    font-family: ", ";\n    font-size: ", ";\n\n    hr {\n      background-color: ", ";\n    }\n  }\n"])), (null == e ? void 0 : e.maxWidth) || "940px", (null == e ? void 0 : e.padding) || "18px", (null == e ? void 0 : e.fontFamily) || '"Calibre", sans-serif', (null == e ? void 0 : e.fontSize) || ot, (null == e ? void 0 : e.dividerColor) || "#d9d9d9");
    },
    ut = function ut(e) {
      var t, n, r, a;
      return (0, et.css)(Je || (Je = rt(["\n  .SpendingSettings {\n    .react-toggle {\n      font-size: ", " !important;\n    }\n    .react-toggle-track {\n      background-color: ", ";\n    }\n\n    .react-toggle:hover .react-toggle-track {\n      background-color: ", ";\n    }\n\n    .react-toggle--checked .react-toggle-track {\n      background-color: ", ";\n    }\n\n    .react-toggle.react-toggle--checked:hover .react-toggle-track {\n      background-color: ", ";\n    }\n  }\n"])), (null == e ? void 0 : e.fontSize) || ot, (null == e || null === (t = e.palette) || void 0 === t || null === (t = t.primary) || void 0 === t ? void 0 : t.main) || at, (null == e || null === (n = e.palette) || void 0 === n || null === (n = n.primary) || void 0 === n ? void 0 : n.main) || at, (null == e || null === (r = e.palette) || void 0 === r || null === (r = r.alert) || void 0 === r ? void 0 : r.main) || it, (null == e || null === (a = e.palette) || void 0 === a || null === (a = a.alert) || void 0 === a ? void 0 : a.main) || it);
    },
    st = function st(e) {
      var t = e.theme;
      return (0, T.useEffect)(function () {
        var e;
        "Mulish" === t.fontFamily && ((e = document.createElement("link")).href = "https://fonts.googleapis.com/css2?family=Mulish:wght@400;600;700;800;900&display=swap", e.rel = "stylesheet", document.head.appendChild(e));
      }, [t]), R().createElement(nt(), {
        styles: (0, et.css)(Qe || (Qe = rt(["\n        ", "\n        ", "\n        ", "\n      "])), lt(t), ct(t), ut(t))
      });
    };
  function dt(e) {
    return dt = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
      return _typeof(e);
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
    }, dt(e);
  }
  function mt() {
    mt = function mt() {
      return t;
    };
    var e,
      t = {},
      n = Object.prototype,
      r = n.hasOwnProperty,
      a = Object.defineProperty || function (e, t, n) {
        e[t] = n.value;
      },
      i = "function" == typeof Symbol ? Symbol : {},
      o = i.iterator || "@@iterator",
      l = i.asyncIterator || "@@asyncIterator",
      c = i.toStringTag || "@@toStringTag";
    function u(e, t, n) {
      return Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), e[t];
    }
    try {
      u({}, "");
    } catch (e) {
      u = function u(e, t, n) {
        return e[t] = n;
      };
    }
    function s(e, t, n, r) {
      var i = t && t.prototype instanceof y ? t : y,
        o = Object.create(i.prototype),
        l = new j(r || []);
      return a(o, "_invoke", {
        value: O(e, n, l)
      }), o;
    }
    function d(e, t, n) {
      try {
        return {
          type: "normal",
          arg: e.call(t, n)
        };
      } catch (e) {
        return {
          type: "throw",
          arg: e
        };
      }
    }
    t.wrap = s;
    var m = "suspendedStart",
      f = "suspendedYield",
      p = "executing",
      h = "completed",
      g = {};
    function y() {}
    function b() {}
    function v() {}
    var E = {};
    u(E, o, function () {
      return this;
    });
    var x = Object.getPrototypeOf,
      S = x && x(x(_([])));
    S && S !== n && r.call(S, o) && (E = S);
    var k = v.prototype = y.prototype = Object.create(E);
    function w(e) {
      ["next", "throw", "return"].forEach(function (t) {
        u(e, t, function (e) {
          return this._invoke(t, e);
        });
      });
    }
    function C(e, t) {
      function n(a, i, o, l) {
        var c = d(e[a], e, i);
        if ("throw" !== c.type) {
          var u = c.arg,
            s = u.value;
          return s && "object" == dt(s) && r.call(s, "__await") ? t.resolve(s.__await).then(function (e) {
            n("next", e, o, l);
          }, function (e) {
            n("throw", e, o, l);
          }) : t.resolve(s).then(function (e) {
            u.value = e, o(u);
          }, function (e) {
            return n("throw", e, o, l);
          });
        }
        l(c.arg);
      }
      var i;
      a(this, "_invoke", {
        value: function value(e, r) {
          function a() {
            return new t(function (t, a) {
              n(e, r, t, a);
            });
          }
          return i = i ? i.then(a, a) : a();
        }
      });
    }
    function O(t, n, r) {
      var a = m;
      return function (i, o) {
        if (a === p) throw Error("Generator is already running");
        if (a === h) {
          if ("throw" === i) throw o;
          return {
            value: e,
            done: !0
          };
        }
        for (r.method = i, r.arg = o;;) {
          var l = r.delegate;
          if (l) {
            var c = A(l, r);
            if (c) {
              if (c === g) continue;
              return c;
            }
          }
          if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
            if (a === m) throw a = h, r.arg;
            r.dispatchException(r.arg);
          } else "return" === r.method && r.abrupt("return", r.arg);
          a = p;
          var u = d(t, n, r);
          if ("normal" === u.type) {
            if (a = r.done ? h : f, u.arg === g) continue;
            return {
              value: u.arg,
              done: r.done
            };
          }
          "throw" === u.type && (a = h, r.method = "throw", r.arg = u.arg);
        }
      };
    }
    function A(t, n) {
      var r = n.method,
        a = t.iterator[r];
      if (a === e) return n.delegate = null, "throw" === r && t.iterator.return && (n.method = "return", n.arg = e, A(t, n), "throw" === n.method) || "return" !== r && (n.method = "throw", n.arg = new TypeError("The iterator does not provide a '" + r + "' method")), g;
      var i = d(a, t.iterator, n.arg);
      if ("throw" === i.type) return n.method = "throw", n.arg = i.arg, n.delegate = null, g;
      var o = i.arg;
      return o ? o.done ? (n[t.resultName] = o.value, n.next = t.nextLoc, "return" !== n.method && (n.method = "next", n.arg = e), n.delegate = null, g) : o : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, g);
    }
    function T(e) {
      var t = {
        tryLoc: e[0]
      };
      1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
    }
    function R(e) {
      var t = e.completion || {};
      t.type = "normal", delete t.arg, e.completion = t;
    }
    function j(e) {
      this.tryEntries = [{
        tryLoc: "root"
      }], e.forEach(T, this), this.reset(!0);
    }
    function _(t) {
      if (t || "" === t) {
        var n = t[o];
        if (n) return n.call(t);
        if ("function" == typeof t.next) return t;
        if (!isNaN(t.length)) {
          var a = -1,
            i = function n() {
              for (; ++a < t.length;) if (r.call(t, a)) return n.value = t[a], n.done = !1, n;
              return n.value = e, n.done = !0, n;
            };
          return i.next = i;
        }
      }
      throw new TypeError(dt(t) + " is not iterable");
    }
    return b.prototype = v, a(k, "constructor", {
      value: v,
      configurable: !0
    }), a(v, "constructor", {
      value: b,
      configurable: !0
    }), b.displayName = u(v, c, "GeneratorFunction"), t.isGeneratorFunction = function (e) {
      var t = "function" == typeof e && e.constructor;
      return !!t && (t === b || "GeneratorFunction" === (t.displayName || t.name));
    }, t.mark = function (e) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(e, v) : (e.__proto__ = v, u(e, c, "GeneratorFunction")), e.prototype = Object.create(k), e;
    }, t.awrap = function (e) {
      return {
        __await: e
      };
    }, w(C.prototype), u(C.prototype, l, function () {
      return this;
    }), t.AsyncIterator = C, t.async = function (e, n, r, a, i) {
      void 0 === i && (i = Promise);
      var o = new C(s(e, n, r, a), i);
      return t.isGeneratorFunction(n) ? o : o.next().then(function (e) {
        return e.done ? e.value : o.next();
      });
    }, w(k), u(k, c, "Generator"), u(k, o, function () {
      return this;
    }), u(k, "toString", function () {
      return "[object Generator]";
    }), t.keys = function (e) {
      var t = Object(e),
        n = [];
      for (var r in t) n.push(r);
      return n.reverse(), function e() {
        for (; n.length;) {
          var r = n.pop();
          if (r in t) return e.value = r, e.done = !1, e;
        }
        return e.done = !0, e;
      };
    }, t.values = _, j.prototype = {
      constructor: j,
      reset: function reset(t) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(R), !t) for (var n in this) "t" === n.charAt(0) && r.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = e);
      },
      stop: function stop() {
        this.done = !0;
        var e = this.tryEntries[0].completion;
        if ("throw" === e.type) throw e.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(t) {
        if (this.done) throw t;
        var n = this;
        function a(r, a) {
          return l.type = "throw", l.arg = t, n.next = r, a && (n.method = "next", n.arg = e), !!a;
        }
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var o = this.tryEntries[i],
            l = o.completion;
          if ("root" === o.tryLoc) return a("end");
          if (o.tryLoc <= this.prev) {
            var c = r.call(o, "catchLoc"),
              u = r.call(o, "finallyLoc");
            if (c && u) {
              if (this.prev < o.catchLoc) return a(o.catchLoc, !0);
              if (this.prev < o.finallyLoc) return a(o.finallyLoc);
            } else if (c) {
              if (this.prev < o.catchLoc) return a(o.catchLoc, !0);
            } else {
              if (!u) throw Error("try statement without catch or finally");
              if (this.prev < o.finallyLoc) return a(o.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(e, t) {
        for (var n = this.tryEntries.length - 1; n >= 0; --n) {
          var a = this.tryEntries[n];
          if (a.tryLoc <= this.prev && r.call(a, "finallyLoc") && this.prev < a.finallyLoc) {
            var i = a;
            break;
          }
        }
        i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
        var o = i ? i.completion : {};
        return o.type = e, o.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, g) : this.complete(o);
      },
      complete: function complete(e, t) {
        if ("throw" === e.type) throw e.arg;
        return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), g;
      },
      finish: function finish(e) {
        for (var t = this.tryEntries.length - 1; t >= 0; --t) {
          var n = this.tryEntries[t];
          if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), R(n), g;
        }
      },
      catch: function _catch(e) {
        for (var t = this.tryEntries.length - 1; t >= 0; --t) {
          var n = this.tryEntries[t];
          if (n.tryLoc === e) {
            var r = n.completion;
            if ("throw" === r.type) {
              var a = r.arg;
              R(n);
            }
            return a;
          }
        }
        throw Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(t, n, r) {
        return this.delegate = {
          iterator: _(t),
          resultName: n,
          nextLoc: r
        }, "next" === this.method && (this.arg = e), g;
      }
    }, t;
  }
  function ft(e, t, n, r, a, i, o) {
    try {
      var l = e[i](o),
        c = l.value;
    } catch (e) {
      return void n(e);
    }
    l.done ? t(c) : Promise.resolve(c).then(r, a);
  }
  function pt(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
      if (null != n) {
        var r,
          a,
          i,
          o,
          l = [],
          c = !0,
          u = !1;
        try {
          if (i = (n = n.call(e)).next, 0 === t) {
            if (Object(n) !== n) return;
            c = !1;
          } else for (; !(c = (r = i.call(n)).done) && (l.push(r.value), l.length !== t); c = !0);
        } catch (e) {
          u = !0, a = e;
        } finally {
          try {
            if (!c && null != n.return && (o = n.return(), Object(o) !== o)) return;
          } finally {
            if (u) throw a;
          }
        }
        return l;
      }
    }(e, t) || function (e, t) {
      if (e) {
        if ("string" == typeof e) return ht(e, t);
        var n = {}.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? ht(e, t) : void 0;
      }
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function ht(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  function gt(e) {
    var t = e.baseUrl,
      n = e.code,
      r = e.codeVerifier,
      a = e.themeConfig,
      i = pt((0, T.useState)(null), 2),
      o = i[0],
      l = i[1],
      c = pt((0, T.useState)(!0), 2),
      u = c[0],
      s = c[1],
      d = pt((0, T.useState)(null), 2),
      m = d[0],
      f = d[1],
      p = pt((0, T.useState)([]), 2),
      h = p[0],
      g = p[1],
      y = pt((0, T.useState)(!1), 2),
      b = y[0],
      E = y[1],
      S = pt((0, T.useState)(""), 2),
      C = S[0],
      j = S[1],
      _ = pt((0, T.useState)(!1), 2),
      q = _[0],
      I = _[1],
      M = ue(a),
      B = "/api/v2/access_tokens";
    (0, T.useEffect)(function () {
      var e = function () {
        var e,
          a = (e = mt().mark(function e() {
            var a, i, o, c, u, d, m, p, h, y, b, v, E;
            return mt().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.prev = 0, s(!0), o = {
                    code: n,
                    codeVerifier: r
                  }, e.next = 5, O().post(B, o);
                case 5:
                  if (c = e.sent, u = c.data.meta.token, O().defaults.baseURL = void 0 !== t ? t : "https://member.truelinkfinancial.com", O().defaults.headers.common.Authorization = "Bearer ".concat(u), O().defaults.headers.post["Content-Type"] = "application/json", d = (0, A.jwtDecode)(u), m = null == d || null === (a = d.account) || void 0 === a ? void 0 : a.id) {
                    e.next = 14;
                    break;
                  }
                  throw new Error("Account ID not found in token");
                case 14:
                  return p = "/api/v2/accounts/".concat(m), e.next = 17, O().get(p);
                case 17:
                  return h = e.sent, y = null == h || null === (i = h.data.data.relationships) || void 0 === i ? void 0 : i.ruleset.data.id, l(y), b = "/api/v2/accounts/".concat(m, "/transactions"), e.next = 23, O().get(b, {
                    params: {
                      "filter[blocked]": !0
                    }
                  });
                case 23:
                  v = e.sent, E = null == v ? void 0 : v.data.data, g(E), e.next = 31;
                  break;
                case 28:
                  e.prev = 28, e.t0 = e.catch(0), f(e.t0);
                case 31:
                  return e.prev = 31, s(!1), e.finish(31);
                case 34:
                case "end":
                  return e.stop();
              }
            }, e, null, [[0, 28, 31, 34]]);
          }), function () {
            var t = this,
              n = arguments;
            return new Promise(function (r, a) {
              var i = e.apply(t, n);
              function o(e) {
                ft(i, r, a, o, l, "next", e);
              }
              function l(e) {
                ft(i, r, a, o, l, "throw", e);
              }
              o(void 0);
            });
          });
        return function () {
          return a.apply(this, arguments);
        };
      }();
      e();
    }, [B, t, n, r]), (0, T.useEffect)(function () {
      C && (I(!1), E(!0));
    }, [C]);
    var N = function N() {
      E(!1), I(!1), j("");
    };
    return u ? R().createElement(v(), {
      sx: {
        textAlign: "center",
        height: 500
      }
    }, R().createElement(x(), {
      color: "success",
      sx: {
        m: 30
      }
    })) : m ? R().createElement(v(), {
      sx: {
        textAlign: "center",
        marginTop: 50,
        height: 200,
        color: "red"
      }
    }, R().createElement("p", null, "Error loading data: ", m.message)) : R().createElement(w.ThemeProvider, {
      theme: M
    }, R().createElement(k(), null), R().createElement(st, {
      theme: M
    }), R().createElement(he, {
      merchantSelected: function merchantSelected(e) {
        j(e.attributes.name);
      },
      transactions: h
    }), b && R().createElement(Ke, {
      addMerchantRule: function addMerchantRule(e) {
        var t = {
          data: {
            type: "merchant_exception",
            attributes: e,
            relationships: {
              spendingSettings: {
                data: {
                  type: "spending_settings",
                  id: o
                }
              }
            }
          }
        };
        O().post("/api/v2/merchant_exceptions/", t).then(function () {
          I(!0);
        });
      },
      blockedTransactionsException: !0,
      editRule: {
        name: C
      },
      merchantAddedSuccess: q,
      onCancel: N,
      onConfirm: N
    }));
  }
  var yt = require("@mui/icons-material/Close"),
    bt = n.n(yt),
    vt = require("@mui/material/IconButton"),
    Et = n.n(vt),
    xt = require("@mui/material/Snackbar"),
    St = n.n(xt),
    kt = require("@mui/icons-material/InfoOutlined"),
    wt = n.n(kt),
    Ct = require("@mui/material/Tooltip"),
    Ot = n.n(Ct);
  function At(e) {
    var t = e.detailText;
    return t ? R().createElement(Ot(), {
      id: "details-tooltip",
      placement: "right",
      sx: {
        fontSize: "20px"
      },
      title: t
    }, R().createElement(wt(), {
      color: "secondary"
    })) : R().createElement("noscript", null);
  }
  At.propTypes = {
    detailText: re().string
  };
  var Tt = At;
  function Rt(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  function jt(e) {
    var t,
      n,
      r = e.checked,
      a = e.onChange,
      i = e.name,
      o = e.id,
      l = e.disabled,
      c = e.disabledTooltipText,
      u = e.readOnly,
      s = (t = (0, T.useState)(!1), n = 2, function (e) {
        if (Array.isArray(e)) return e;
      }(t) || function (e, t) {
        var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (null != n) {
          var r,
            a,
            i,
            o,
            l = [],
            c = !0,
            u = !1;
          try {
            if (i = (n = n.call(e)).next, 0 === t) {
              if (Object(n) !== n) return;
              c = !1;
            } else for (; !(c = (r = i.call(n)).done) && (l.push(r.value), l.length !== t); c = !0);
          } catch (e) {
            u = !0, a = e;
          } finally {
            try {
              if (!c && null != n.return && (o = n.return(), Object(o) !== o)) return;
            } finally {
              if (u) throw a;
            }
          }
          return l;
        }
      }(t, n) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return Rt(e, t);
          var n = {}.toString.call(e).slice(8, -1);
          return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Rt(e, t) : void 0;
        }
      }(t, n) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }()),
      d = s[0],
      m = s[1],
      f = "react-toggle\n      ".concat(r ? "react-toggle--checked" : "", "\n      ").concat(d ? "react-toggle--focus" : "", "\n      ").concat(l ? "react-toggle--disabled" : "", "\n      ").concat(u ? "readOnly" : "").trim();
    return u ? R().createElement("div", {
      className: f
    }, R().createElement(Ot(), {
      title: l ? c : ""
    }, R().createElement("div", {
      className: "react-toggle-track"
    }, R().createElement("div", {
      className: "react-toggle-track-block read-only"
    }, "BLOCKED"), R().createElement("div", {
      className: "react-toggle-track-allow read-only"
    }, "ALLOWED")))) : R().createElement("div", {
      className: f
    }, R().createElement(Ot(), {
      title: l ? c : ""
    }, R().createElement("div", {
      className: "react-toggle-track"
    }, R().createElement("div", {
      className: "react-toggle-track-block"
    }, "BLOCK"), R().createElement("div", {
      className: "react-toggle-track-allow"
    }, "ALLOW"))), R().createElement("div", {
      className: "react-toggle-thumb"
    }), R().createElement("input", {
      checked: r,
      className: "react-toggle-screenreader-only",
      disabled: l,
      id: o,
      name: i,
      onBlur: function onBlur() {
        m(!1);
      },
      onChange: a,
      onFocus: function onFocus() {
        m(!0);
      },
      type: "checkbox"
    }));
  }
  jt.propTypes = {
    checked: re().bool.isRequired,
    disabled: re().bool,
    disabledTooltipText: re().string,
    id: re().string.isRequired,
    name: re().string,
    onChange: re().func.isRequired,
    readOnly: re().bool
  };
  var _t = jt;
  function qt(e) {
    var t = e.category,
      n = e.checkedCallback,
      r = e.detailText,
      a = e.disabled,
      i = void 0 !== a && a,
      o = e.disabledTooltipText,
      l = void 0 === o ? "" : o,
      c = e.hoverText,
      u = e.hr,
      s = void 0 === u || u,
      d = e.is_checked,
      m = e.name,
      f = e.readOnly,
      p = e.rules,
      h = e.text,
      g = e.uncheckedCallback,
      y = e.updateChecked,
      b = e.updateUnChecked,
      v = (0, T.useRef)(),
      E = m || "toggle_".concat(h.replace(/[^a-z0-9]/gi, "_"));
    return R().createElement("div", {
      className: "toggleLine",
      ref: v
    }, R().createElement(We(), {
      alignItems: "center",
      direction: "row",
      justifyContent: {
        xs: "space-between",
        sm: "flex-start"
      },
      spacing: {
        xs: 1,
        sm: 2
      }
    }, R().createElement("label", {
      "data-original-title": c,
      "data-placement": "right",
      "data-toggle": "tooltip",
      htmlFor: E,
      style: {
        display: "flex"
      }
    }, R().createElement(_t, {
      checked: d,
      disabled: i,
      disabledTooltipText: l,
      id: E,
      name: m,
      onChange: function onChange(e) {
        e.target.checked ? (n && n(), y(p, t)) : b(p, t, g);
      },
      readOnly: f
    }), R().createElement(Q(), {
      component: "div",
      variant: "body1"
    }, h)), R().createElement(Tt, {
      detailText: r
    })), R().createElement("hr", {
      className: s ? "" : "hidden"
    }));
  }
  function It(e) {
    var t = e.blockRules,
      n = e.addBlockRules,
      r = e.disableCashAccess,
      a = e.readOnly,
      i = e.removeBlockRules;
    return R().createElement("div", null, R().createElement(Q(), {
      variant: "h2"
    }, "Cash Access"), R().createElement("hr", {
      className: "title-hr"
    }), R().createElement(qt, {
      category: "cashAccess",
      disabled: r,
      is_checked: !!t.blockATM,
      name: "blockATM",
      readOnly: a,
      rules: {
        blockATM: !0
      },
      text: "Cash withdrawals at ATMs",
      updateChecked: n,
      updateUnChecked: i
    }), R().createElement(qt, {
      category: "cashAccess",
      disabled: r,
      is_checked: !!t.blockSignatureCash,
      name: "blockSignatureCash",
      readOnly: a,
      rules: {
        blockSignatureCash: !0
      },
      text: "Cash withdrawals inside a bank",
      updateChecked: n,
      updateUnChecked: i
    }), R().createElement(qt, {
      category: "cashAccess",
      disabled: r,
      is_checked: !!t.blockPOSCash,
      name: "blockPOSCash",
      readOnly: a,
      rules: {
        blockPOSCash: !0
      },
      text: "Cash-back at time of purchase",
      updateChecked: n,
      updateUnChecked: i
    }));
  }
  qt.propTypes = {
    is_checked: re().bool.isRequired,
    rules: re().object.isRequired,
    text: re().string.isRequired,
    updateChecked: re().func.isRequired,
    updateUnChecked: re().func.isRequired,
    category: re().string,
    checkedCallback: re().func,
    detailText: re().string,
    disabled: re().bool,
    disabledTooltipText: re().string,
    hoverText: re().string,
    hr: re().bool,
    name: re().string,
    readOnly: re().bool,
    uncheckedCallback: re().func
  }, It.propTypes = {
    blockRules: re().object.isRequired,
    addBlockRules: re().func.isRequired,
    readOnly: re().bool,
    disableCashAccess: re().bool,
    removeBlockRules: re().func.isRequired
  };
  var Mt = require("@mui/material/Grid"),
    Bt = n.n(Mt);
  function Nt(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  function Pt(e, t, n) {
    var r,
      a,
      i = (r = Object.entries(e)[0], a = 2, function (e) {
        if (Array.isArray(e)) return e;
      }(r) || function (e, t) {
        var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (null != n) {
          var r,
            a,
            i,
            o,
            l = [],
            c = !0,
            u = !1;
          try {
            if (i = (n = n.call(e)).next, 0 === t) {
              if (Object(n) !== n) return;
              c = !1;
            } else for (; !(c = (r = i.call(n)).done) && (l.push(r.value), l.length !== t); c = !0);
          } catch (e) {
            u = !0, a = e;
          } finally {
            try {
              if (!c && null != n.return && (o = n.return(), Object(o) !== o)) return;
            } finally {
              if (u) throw a;
            }
          }
          return l;
        }
      }(r, a) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return Nt(e, t);
          var n = {}.toString.call(e).slice(8, -1);
          return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Nt(e, t) : void 0;
        }
      }(r, a) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }()),
      o = i[0],
      l = i[1];
    return "maxTransactionSize" === o || "maxTransactionSizeCash" === o ? {
      id: "spendingLimitsChange",
      description: l ? "Set ".concat(o, " to ").concat(l) : "Remove ".concat(o),
      data: {
        type: o,
        amount: l
      }
    } : ["topLineProtection", "cashAccess"].includes(t) ? {
      id: "".concat(t, "Change"),
      description: "Set ".concat(o, " to ").concat(n ? "true" : "false"),
      data: {
        type: o,
        blocked: n
      }
    } : "temporaryOverrides" === t ? {
      id: "".concat(t, "Change"),
      description: "Set ".concat(o, " to ").concat(n ? "true" : "false"),
      data: {
        type: o,
        enabled: n
      }
    } : "category" === t ? {
      id: "".concat(t, "Change"),
      description: "Category ".concat(e.id, " is now ").concat(e.blocked ? "allowed" : "blocked"),
      data: {
        type: e.id,
        blocked: !e.blocked
      }
    } : "budget" === t ? {
      id: "".concat(t, "Change"),
      description: "".concat(e.budget ? "Set budget" : "Remove budget"),
      data: e.budget
    } : "curfew" === t ? {
      id: "".concat(t, "Change"),
      description: "".concat(e.curfew ? "Set curfew" : "Remove curfew"),
      data: e.curfew
    } : "merchantExceptions" === t ? {
      id: "".concat(t, "Change"),
      description: "Category ".concat(e.name, " is now ").concat("block_all" === e.action ? "blocked" : "allowed"),
      data: e
    } : "deleteMerchant" === t ? {
      id: "".concat(t, "Change"),
      description: "Merchant ".concat(e.id, " has been deleted"),
      data: e
    } : "categoryException" === t ? {
      id: "".concat(t, "Change"),
      description: "Category ".concat(e.id, " is now ").concat(e.blocked ? "allowed via exception" : "blocked"),
      data: {
        type: e.id,
        blocked: !0,
        allowedViaException: e.blocked
      }
    } : {
      id: "".concat(t, "Change"),
      description: "Unhandled category: ".concat(t),
      data: {
        type: e,
        isAddingRule: n
      }
    };
  }
  function Lt(e, t) {
    return Pt(e, t, !0);
  }
  function zt(e, t) {
    return Pt(e, t, !1);
  }
  var Dt = require("@mui/icons-material/Edit"),
    Ft = n.n(Dt);
  function Ut(e) {
    return e.charAt(0).toUpperCase() + e.slice(1);
  }
  function Wt(e) {
    return Wt = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
      return _typeof(e);
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
    }, Wt(e);
  }
  function Vt(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function Ht(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Vt(Object(n), !0).forEach(function (t) {
        $t(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Vt(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  function $t(e, t, n) {
    return (t = function (e) {
      var t = function (e, t) {
        if ("object" != Wt(e) || !e) return e;
        var n = e[Symbol.toPrimitive];
        if (void 0 !== n) {
          var r = n.call(e, "string");
          if ("object" != Wt(r)) return r;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(e);
      }(e);
      return "symbol" == Wt(t) ? t : t + "";
    }(t)) in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  function Gt(e) {
    var t,
      n = e.updateRules,
      r = e.showEditModal,
      a = e.readOnly,
      i = e.rule,
      o = (0, T.useCallback)(function (e) {
        var t, r;
        null !== (t = e.target) && void 0 !== t && t.checked ? i.action = "block_all" : null !== (r = i.limit) && void 0 !== r && r.amount ? i.action = "enforce_limit" : i.action = "allow_all", n(i);
      }, [n, i]),
      l = (0, T.useCallback)(function () {
        r(i);
      }, [r, i]),
      c = (0, T.useCallback)(function () {
        return "block_all" === i.action ? "-" : "enforce_limit" === i.action ? "Limit: $".concat(null === (e = i.limit) || void 0 === e ? void 0 : e.amount) : "No limit";
        var e;
      }, [i]),
      u = "specific_rule_".concat(null === (t = i.name) || void 0 === t ? void 0 : t.replace(/[^a-z0-9]/gi, "_")),
      s = {
        color: "#828282",
        display: {
          xs: "flex",
          sm: "none"
        },
        paddingBottom: "10px"
      };
    return R().createElement(Bt(), {
      alignItems: "center",
      className: "specific-rule-row",
      container: !0,
      rowSpacing: 5,
      sx: {
        mb: {
          xs: "10px",
          sm: "0"
        }
      }
    }, R().createElement(Bt(), {
      item: !0,
      sm: 3,
      xs: 6
    }, R().createElement(v(), {
      sx: s
    }, "MY SETTING"), R().createElement("label", {
      className: "toggle_label",
      htmlFor: u
    }, R().createElement(_t, {
      checked: "block_all" === i.action,
      id: u,
      onChange: o,
      readOnly: !0
    }))), R().createElement(Bt(), {
      className: "specific-rule-name",
      item: !0,
      sm: 3,
      sx: {
        textAlign: {
          xs: "end",
          sm: "start"
        }
      },
      xs: 6
    }, R().createElement(v(), {
      sx: Ht(Ht({}, s), {}, {
        justifyContent: "end"
      })
    }, "MERCHANT"), i.name.toLowerCase().replace(/_/g, " ").split(" ").map(Ut).join(" ")), R().createElement(Bt(), {
      item: !0,
      sm: 5,
      xs: 10
    }, R().createElement(v(), {
      sx: s
    }, "MAXIMUM TRANSACTION SIZE"), c()), R().createElement(Bt(), {
      item: !0,
      sm: 1,
      sx: {
        textAlign: "end"
      },
      xs: 2
    }, !a && R().createElement(L(), {
      color: "tertiary",
      onClick: l,
      startIcon: R().createElement(Ft(), null)
    }, "Edit")));
  }
  Gt.propTypes = {
    updateRules: re().func.isRequired,
    rule: re().object.isRequired,
    showEditModal: re().func,
    readOnly: re().bool
  };
  var Yt = Gt;
  function Kt(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
      if (null != n) {
        var r,
          a,
          i,
          o,
          l = [],
          c = !0,
          u = !1;
        try {
          if (i = (n = n.call(e)).next, 0 === t) {
            if (Object(n) !== n) return;
            c = !1;
          } else for (; !(c = (r = i.call(n)).done) && (l.push(r.value), l.length !== t); c = !0);
        } catch (e) {
          u = !0, a = e;
        } finally {
          try {
            if (!c && null != n.return && (o = n.return(), Object(o) !== o)) return;
          } finally {
            if (u) throw a;
          }
        }
        return l;
      }
    }(e, t) || function (e, t) {
      if (e) {
        if ("string" == typeof e) return Zt(e, t);
        var n = {}.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Zt(e, t) : void 0;
      }
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function Zt(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  function Xt(e) {
    var t = e.axios,
      n = e.fetchSpendingSetting,
      r = e.merchantExceptions,
      a = e.onChange,
      i = e.readOnly,
      o = e.ruleSetId,
      l = e.showAddMerchantButton,
      c = "/api/v2/merchant_exceptions/",
      u = Kt((0, T.useState)(!1), 2),
      s = u[0],
      d = u[1],
      m = Kt((0, T.useState)(null), 2),
      f = m[0],
      p = m[1],
      h = Kt((0, T.useState)(!1), 2),
      g = h[0],
      y = h[1],
      b = (0, T.useCallback)(function (e) {
        var r = Lt(e, "merchantExceptions");
        a && a(r);
        var i = {
          data: {
            type: "merchant_exception",
            attributes: e,
            relationships: {
              spendingSettings: {
                data: {
                  type: "spending_settings",
                  id: o
                }
              }
            }
          }
        };
        e.id ? t.patch("".concat(c).concat(e.id), i).then(function () {
          y(!0), n();
        }) : t.post(c, i).then(function () {
          y(!0), n();
        });
      }, [t, n, c, o]),
      v = (0, T.useCallback)(function (e) {
        if (e.id) {
          var r = Lt(e, "deleteMerchant");
          a && a(r), t.delete("".concat(c).concat(e.id)).then(function () {
            n();
          });
        }
      }, [t, n, c]),
      E = (0, T.useCallback)(function (e) {
        p(e), y(!1), d(function () {
          return !0;
        });
      }, []),
      x = (0, T.useCallback)(function () {
        p(null), d(!1);
      }, []),
      S = (0, T.useCallback)(function (e) {
        var t = e.attributes;
        return t.id = e.id, R().createElement(Yt, {
          key: t.id,
          readOnly: i,
          rule: t,
          showEditModal: E,
          updateRules: b
        });
      }, [b, i, E]);
    return R().createElement("div", null, R().createElement(We(), {
      alignItems: "center",
      direction: "row",
      justifyContent: "space-between"
    }, R().createElement(Q(), {
      variant: "h2"
    }, "Merchant Exceptions"), !i && l && R().createElement(L(), {
      color: "tertiary",
      onClick: function onClick() {
        return E();
      },
      startIcon: R().createElement(_(), null),
      sx: {
        display: {
          xs: "none",
          sm: "flex"
        }
      }
    }, "Add Merchant Exceptions")), R().createElement("hr", {
      style: {
        marginTop: "0px"
      }
    }), r.length > 0 ? R().createElement("div", {
      className: "specific_rules_table"
    }, R().createElement(Bt(), {
      className: "table-title",
      container: !0,
      sx: {
        display: {
          xs: "none",
          sm: "flex"
        }
      }
    }, R().createElement(Bt(), {
      item: !0,
      xs: 3
    }, "MY SETTING"), R().createElement(Bt(), {
      item: !0,
      xs: 3
    }, "MERCHANT"), R().createElement(Bt(), {
      item: !0,
      xs: 5
    }, "MAXIMUM TRANSACTION SIZE"), !i && R().createElement(Bt(), {
      item: !0,
      sx: {
        textAlign: "end"
      },
      xs: 1
    }, "EDIT"), R().createElement("hr", {
      style: {
        marginBottom: "0px"
      }
    })), r.map(S), R().createElement(We(), {
      direction: "row",
      justifyContent: "center",
      sx: {
        display: {
          xs: "flex",
          sm: "none"
        }
      }
    }, !i && l && R().createElement(L(), {
      color: "tertiary",
      onClick: function onClick() {
        return E();
      },
      startIcon: R().createElement(_(), null)
    }, "Add Merchant Exceptions"))) : R().createElement("div", {
      className: "empty-state-box"
    }, "No Merchant Exceptions"), s && R().createElement(Ke, {
      addMerchantRule: b,
      axios: t,
      deleteMerchantRule: v,
      editRule: f,
      merchantAddedSuccess: g,
      onCancel: x,
      onConfirm: x
    }));
  }
  Xt.propTypes = {
    axios: re().func.isRequired,
    onChange: re().func,
    merchantExceptions: re().array.isRequired,
    readOnly: re().bool
  };
  var Jt = Xt,
    Qt = require("@mui/icons-material/Compress"),
    en = n.n(Qt),
    tn = require("@mui/icons-material/Expand"),
    nn = n.n(tn),
    rn = require("@mui/icons-material/Block"),
    an = n.n(rn),
    on = require("@mui/icons-material/ExpandMore"),
    ln = n.n(on),
    cn = require("@mui/icons-material/Flight"),
    un = n.n(cn),
    sn = require("@mui/icons-material/HealthAndSafety"),
    dn = n.n(sn),
    mn = require("@mui/icons-material/MedicalServices"),
    fn = n.n(mn),
    pn = require("@mui/icons-material/Receipt"),
    hn = n.n(pn),
    gn = require("@mui/icons-material/ShoppingCart"),
    yn = n.n(gn),
    bn = require("@mui/material/Accordion"),
    vn = n.n(bn),
    En = require("@mui/material/AccordionDetails"),
    xn = n.n(En),
    Sn = require("@mui/material/AccordionSummary"),
    kn = n.n(Sn),
    wn = require("underscore"),
    Cn = require("@mui/material/InputAdornment"),
    On = n.n(Cn),
    An = require("@mui/material/InputLabel"),
    Tn = n.n(An),
    Rn = require("@mui/material/OutlinedInput"),
    jn = n.n(Rn);
  function _n(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  var qn = (0, T.forwardRef)(function (e, t) {
    var n,
      r,
      a = e.disabled,
      i = e.label,
      o = e.name,
      l = e.onBlur,
      c = e.onEnter,
      u = e.textfieldValue,
      s = (n = (0, T.useState)(u), r = 2, function (e) {
        if (Array.isArray(e)) return e;
      }(n) || function (e, t) {
        var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (null != n) {
          var r,
            a,
            i,
            o,
            l = [],
            c = !0,
            u = !1;
          try {
            if (i = (n = n.call(e)).next, 0 === t) {
              if (Object(n) !== n) return;
              c = !1;
            } else for (; !(c = (r = i.call(n)).done) && (l.push(r.value), l.length !== t); c = !0);
          } catch (e) {
            u = !0, a = e;
          } finally {
            try {
              if (!c && null != n.return && (o = n.return(), Object(o) !== o)) return;
            } finally {
              if (u) throw a;
            }
          }
          return l;
        }
      }(n, r) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return _n(e, t);
          var n = {}.toString.call(e).slice(8, -1);
          return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? _n(e, t) : void 0;
        }
      }(n, r) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }()),
      d = s[0],
      m = s[1];
    (0, T.useEffect)(function () {
      m(u);
    }, [u]);
    var f = (0, T.useCallback)(function (e) {
        m(e.target.value);
      }, []),
      p = (0, T.useCallback)(function (e) {
        "Enter" !== e.key || a || c();
      }, [a, c]);
    return R().createElement(Be(), {
      disabled: a,
      sx: {
        m: 1
      }
    }, R().createElement(Tn(), {
      htmlFor: "".concat(o, "-input-amount")
    }, i), R().createElement(jn(), {
      disabled: a,
      id: "".concat(o, "-input-amount"),
      inputProps: {
        maxLength: 5,
        "aria-label": i
      },
      inputRef: t,
      name: o,
      onBlur: l,
      onChange: f,
      onKeyDown: p,
      size: "small",
      startAdornment: R().createElement(On(), {
        position: "start"
      }, "$"),
      sx: {
        width: "120px"
      },
      type: "text",
      value: d
    }));
  });
  qn.propTypes = {
    disabled: re().bool,
    onBlur: re().func.isRequired,
    onEnter: re().func.isRequired,
    textfieldValue: re().string,
    label: re().string,
    name: re().string
  };
  var In = qn,
    Mn = (0, T.forwardRef)(function (e, t) {
      var n = e.checked,
        r = e.onChange,
        a = e.label,
        i = e.name,
        o = e.value,
        l = e.id,
        c = e.disabled,
        u = (0, T.useRef)(null),
        s = R().createElement(Ie(), {
          "aria-label": i,
          checked: n,
          color: "primary",
          "data-testid": "".concat(l, "-checkbox"),
          disabled: c,
          id: "checkbox-".concat(l),
          inputRef: u,
          name: i,
          onChange: r,
          type: "checkbox",
          value: o
        }),
        d = (0, T.useCallback)(function () {
          return u.current;
        }, []);
      return R().useImperativeHandle(t, function () {
        return {
          getUnderlyingInput: d
        };
      }), R().createElement(Pe(), {
        control: s,
        label: a
      });
    });
  Mn.propTypes = {
    checked: re().bool.isRequired,
    onChange: re().func.isRequired,
    name: re().string,
    label: re().oneOfType([re().string, re().object]),
    value: re().string,
    id: re().string,
    disabled: re().bool
  };
  var Bn = Mn;
  function Nn(e) {
    var t = e.updateChecked,
      n = e.updateUnChecked,
      r = e.isChecked,
      a = e.text,
      i = e.checkedCallback,
      o = e.detailText,
      l = e.disabled,
      c = e.hidden,
      u = e.readOnly,
      s = e.hr,
      d = void 0 === s || s,
      m = e.id,
      f = e.rule,
      p = e.name,
      h = e.textfield,
      g = e.uncheckedCallback,
      y = (0, T.useRef)(null),
      b = (0, T.useRef)(null),
      E = (0, T.useRef)(null),
      x = (0, T.useCallback)(function (e) {
        var t,
          n = y.current;
        return h ? "" === n.value.replace(/ /g, "") ? t = "" : n && (t = Number.parseFloat(n.value.replace(/[^0-9.]/g, "") || 0).toFixed(0), n.value = t) : t = "on", e || (t = ""), t;
      }, [h]),
      S = (0, T.useCallback)(function (e) {
        var r = {},
          a = e.name,
          o = e.checked;
        a ? r[a] = x(o) : r = f, o && "" !== r[a] ? (i && i(), t(r)) : (g && g(), n(r));
      }, [i, x, f, g, t, n]),
      k = (0, T.useCallback)(function (e) {
        l || S(e.target);
      }, [l, S]),
      w = (0, T.useCallback)(function () {
        r ? S(b.current.getUnderlyingInput()) : $(b.current).click();
      }, [r, S]),
      C = (0, T.useCallback)(function () {
        r && S(b.current.getUnderlyingInput());
      }, [r, S]);
    if (c) return null;
    var O,
      A = h && R().createElement(In, {
        disabled: !r,
        label: "Input Amount",
        name: p,
        onBlur: C,
        onEnter: w,
        ref: y,
        textfieldValue: h
      });
    return u ? r ? R().createElement("li", {
      style: {
        marginBottom: "5px"
      }
    }, a) : null : (o && (O = R().createElement(v(), {
      sx: {
        ml: -1,
        mr: 5,
        display: "flex",
        alignItems: "center"
      }
    }, a, R().createElement(Tt, {
      detailText: o
    }))), R().createElement("div", {
      ref: E
    }, R().createElement(Bt(), {
      alignItems: "center",
      container: !0,
      "data-testid": m
    }, R().createElement(Bt(), {
      item: !0,
      sm: h ? 4 : 12,
      sx: {
        display: "flex",
        alignItems: "center"
      }
    }, R().createElement(Bn, {
      checked: r,
      disabled: l,
      id: m,
      label: O || a,
      name: p,
      onChange: k,
      ref: b
    })), R().createElement(Bt(), {
      item: !0,
      sm: 3
    }, A)), R().createElement("hr", {
      className: d ? "" : "hidden"
    })));
  }
  Nn.propTypes = {
    updateChecked: re().func.isRequired,
    updateUnChecked: re().func.isRequired,
    isChecked: re().bool.isRequired,
    text: re().string.isRequired,
    checkedCallback: re().func,
    detailText: re().string,
    disabled: re().bool,
    hidden: re().bool,
    readOnly: re().bool,
    hr: re().bool,
    id: re().string,
    rule: re().string,
    name: re().string,
    textfield: re().string,
    uncheckedCallback: re().func
  };
  var Pn = Nn,
    Ln = require("@mui/material/DialogContentText"),
    zn = n.n(Ln);
  function Dn(e) {
    var t = e.rule,
      n = e.onCancel,
      r = e.onConfirm,
      a = t.id.replace("UTILITIES", "Utilities").replace("MEDICAL_AND_CARE", "Medical and Care").replace("FOOD_RESTAURANT", "Restaurant delivery").replace("PHONE_TV_CABLE", "Phone, TV, and Cable"),
      i = "You have chosen to always allow payments for ".concat(a),
      o = "If you select to allow payments for ".concat(a, " here, the block you put in place on payments for ").concat(a, " in the spending categories section below will be removed. Are you sure that's what you want?");
    return R().createElement(ve(), {
      maxWidth: "sm",
      open: !0
    }, R().createElement(Ce(), null, i), R().createElement(ke(), null, R().createElement(zn(), null, o)), R().createElement(xe(), null, R().createElement(L(), {
      color: "secondary",
      onClick: n,
      variant: "outlined"
    }, "Cancel"), R().createElement(L(), {
      color: "secondary",
      onClick: r,
      variant: "contained"
    }, "Confirm")));
  }
  function Fn(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
      if (null != n) {
        var r,
          a,
          i,
          o,
          l = [],
          c = !0,
          u = !1;
        try {
          if (i = (n = n.call(e)).next, 0 === t) {
            if (Object(n) !== n) return;
            c = !1;
          } else for (; !(c = (r = i.call(n)).done) && (l.push(r.value), l.length !== t); c = !0);
        } catch (e) {
          u = !0, a = e;
        } finally {
          try {
            if (!c && null != n.return && (o = n.return(), Object(o) !== o)) return;
          } finally {
            if (u) throw a;
          }
        }
        return l;
      }
    }(e, t) || function (e, t) {
      if (e) {
        if ("string" == typeof e) return Un(e, t);
        var n = {}.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Un(e, t) : void 0;
      }
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function Un(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  function Wn(e) {
    var t = e.addCategoryRule,
      n = e.hidden,
      r = e.readOnly,
      a = e.spendingCategoryRules,
      i = (0, T.useCallback)(function (e) {
        return a.find(function (t) {
          return t.id === e;
        });
      }, [a]),
      o = Fn((0, T.useState)(null), 2),
      l = o[0],
      c = o[1],
      u = Fn((0, T.useState)(!1), 2),
      s = u[0],
      d = u[1],
      m = Fn((0, T.useState)(!1), 2),
      f = m[0],
      p = m[1],
      h = Fn((0, T.useState)(!1), 2),
      g = h[0],
      y = h[1],
      b = Fn((0, T.useState)(!1), 2),
      v = b[0],
      E = b[1],
      x = function x(e) {
        var n = i(e);
        n.blocked ? c({
          rule: n
        }) : t(n, !0, !0);
      },
      S = function S(e) {
        var n = i(e);
        t(n, !1, !0);
      },
      k = (0, T.useCallback)(function () {
        t(l.rule, !0, !0), c(null);
      }, [l, t]);
    return (0, T.useEffect)(function () {
      var e, t, n, r;
      d((null === (e = i("UTILITIES")) || void 0 === e ? void 0 : e.allowedViaException) || !1), p((null === (t = i("MEDICAL_AND_CARE")) || void 0 === t ? void 0 : t.allowedViaException) || !1), y((null === (n = i("FOOD_RESTAURANT")) || void 0 === n ? void 0 : n.allowedViaException) || !1), E((null === (r = i("PHONE_TV_CABLE")) || void 0 === r ? void 0 : r.allowedViaException) || !1);
    }, [a, i]), R().createElement("div", {
      className: n ? "hidden" : null,
      style: {
        marginLeft: "24px",
        marginTop: "20px",
        marginBottom: "20px"
      }
    }, l && R().createElement(Dn, {
      onCancel: function onCancel() {
        c(null);
      },
      onConfirm: k,
      rule: l.rule
    }), R().createElement(Q(), {
      sx: {
        mb: 1,
        fontWeight: "bold"
      },
      variant: "body2"
    }, "Exceptions"), R().createElement(Pn, {
      hr: !1,
      id: "exception-utilities",
      isChecked: s,
      readOnly: r,
      rule: "UTILITIES",
      text: "Allow utility bill payments online or by phone",
      updateChecked: x,
      updateUnChecked: S
    }), R().createElement(Pn, {
      hr: !1,
      id: "exception-medical-and-care",
      isChecked: f,
      readOnly: r,
      rule: "MEDICAL_AND_CARE",
      text: "Allow medical and health payments online or by phone",
      updateChecked: x,
      updateUnChecked: S
    }), R().createElement(Pn, {
      hr: !1,
      id: "exception-food-restaurant",
      isChecked: g,
      readOnly: r,
      rule: "FOOD_RESTAURANT",
      text: "Allow restaurant delivery payment online or by phone",
      updateChecked: x,
      updateUnChecked: S
    }), R().createElement(Pn, {
      hr: !1,
      id: "exception-phone-tv-cable",
      isChecked: v,
      readOnly: r,
      rule: "PHONE_TV_CABLE",
      text: "Allow phone, TV, and cable payments online or by phone",
      updateChecked: x,
      updateUnChecked: S
    }));
  }
  function Vn(e) {
    var t = e.addBlockRules,
      n = e.addCategoryRule,
      r = e.blockRules,
      a = e.disabledSpendingSettings,
      i = e.readOnly,
      o = e.removeBlockRules,
      l = e.spendingCategoryRules,
      c = !r.blockCardNotPresent,
      u = R().createElement(qt, {
        category: "topLineProtection",
        detailText: "The ScamWatch list contains merchants whose behavior has been flagged by multiple users and therefore is likely fraudulent. We recommend blocking these.",
        disabled: null == a ? void 0 : a.includes("SCAM_WATCH"),
        hr: !1,
        is_checked: !!r.blockScamWatch,
        name: "blockScamWatch",
        readOnly: i,
        rules: {
          blockScamWatch: !0
        },
        text: "True Link’s Scamwatch",
        updateChecked: t,
        updateUnChecked: o
      }),
      s = R().createElement(qt, {
        category: "topLineProtection",
        disabled: null == a ? void 0 : a.includes("ONLINE_PURCHASES"),
        hr: !1,
        is_checked: !!r.blockCardNotPresent,
        name: "blockCardNotPresent",
        readOnly: i,
        rules: {
          blockCardNotPresent: !0
        },
        text: "Online & phone purchases",
        uncheckedCallback: function uncheckedCallback() {
          o({
            allowlistSemantics: "UTILITIES;MEDICAL_AND_CARE;FOOD_RESTAURANT;PHONE_TV_CABLE",
            maxTransactionSizeBySemantic: {
              UTILITIES: "",
              MEDICAL_AND_CARE: "",
              FOOD_RESTAURANT: "",
              PHONE_TV_CABLE: ""
            }
          }, "topLineProtection");
        },
        updateChecked: t,
        updateUnChecked: o
      }),
      d = R().createElement(qt, {
        category: "topLineProtection",
        disabled: null == a ? void 0 : a.includes("INTERNATIONAL_TRANSACTIONS"),
        hr: !1,
        is_checked: !!r.blockInternationalTransactions,
        name: "blockInternationalTransactions",
        readOnly: i,
        rules: {
          blockInternationalTransactions: !0
        },
        text: "International transactions",
        updateChecked: t,
        updateUnChecked: o
      }),
      m = R().createElement(Wn, {
        addCategoryRule: n,
        hidden: c,
        readOnly: i,
        spendingCategoryRules: l
      });
    return R().createElement("div", {
      className: "top-line-protections-container"
    }, R().createElement(Bt(), {
      alignItems: "center",
      columnSpacing: 2,
      container: !0
    }, R().createElement(Bt(), {
      className: "specific-rule-grid-item",
      item: !0,
      md: 6,
      sm: 12
    }, u), R().createElement(Bt(), {
      className: "specific-rule-grid-item",
      item: !0,
      md: 6,
      sm: 12
    }, d), R().createElement(Bt(), {
      className: "specific-rule-grid-item",
      item: !0,
      md: 6,
      sm: 12
    }, s, m)));
  }
  function Hn() {
    return Hn = Object.assign ? Object.assign.bind() : function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];
        for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
      return e;
    }, Hn.apply(null, arguments);
  }
  function $n(e) {
    var t,
      n,
      r,
      a,
      i,
      o,
      l = e.addBlockRules,
      c = e.blockRules,
      u = e.disabledSpendingSettings,
      s = e.spendingCategoryRules,
      d = e.readOnly,
      m = e.removeBlockRules,
      f = e.addCategoryRule,
      p = e.removeCategoryRule,
      h = s.filter(function (e) {
        return e.tags.includes("commonly_blocked");
      }),
      g = s.filter(function (e) {
        return e.tags.includes("services");
      }),
      y = s.filter(function (e) {
        return e.tags.includes("shopping");
      }),
      b = s.filter(function (e) {
        return e.tags.includes("health_and_medical");
      }),
      E = s.filter(function (e) {
        return e.tags.includes("travel_and_entertainment");
      }),
      x = function x(e) {
        return R().createElement(Bt(), {
          alignItems: "center",
          columnSpacing: 2,
          container: !0
        }, e.map(function (t, n) {
          return R().createElement(Bt(), {
            className: "specific-rule-grid-item",
            item: !0,
            key: "spending-categories-item-".concat(n),
            md: 6,
            sm: 12
          }, (r = e[n], (0, wn.isEmpty)(r) ? R().createElement("div", null) : R().createElement(qt, Hn({
            disabled: r.allowedViaException || r.disableCategory,
            disabledTooltipText: r.allowedViaException ? "You've already allowed this category in the Top-line Protections section of your Spending Monitor" : "",
            hr: !1,
            is_checked: r.blocked,
            readOnly: d,
            updateChecked: function updateChecked() {
              return f(r);
            },
            updateUnChecked: function updateUnChecked() {
              return p(r);
            }
          }, r))));
          var r;
        }));
      },
      S = R().createElement(Vn, {
        addBlockRules: l,
        addCategoryRule: f,
        blockRules: c,
        disabledSpendingSettings: u,
        readOnly: d,
        removeBlockRules: m,
        spendingCategoryRules: s
      }),
      k = [{
        name: "Top Line Protection",
        key: "top_line_protections",
        blocked: (o = 0, ["blockCardNotPresent", "blockScamWatch", "blockInternationalTransactions"].forEach(function (e) {
          Object.prototype.hasOwnProperty.call(c, e) && o++;
        }), o),
        total: 3,
        table: S,
        icon: R().createElement(dn(), {
          color: "primary",
          fontSize: "small"
        })
      }, {
        name: "Commonly Blocked",
        key: "commonly_blocked",
        blocked: (null === (t = h.filter(function (e) {
          return e.blocked;
        })) || void 0 === t ? void 0 : t.length) || 0,
        total: h.length,
        table: x(h),
        icon: R().createElement(an(), {
          color: "primary",
          fontSize: "small"
        })
      }, {
        name: "Services & Bills",
        key: "services",
        blocked: (null === (n = g.filter(function (e) {
          return e.blocked;
        })) || void 0 === n ? void 0 : n.length) || 0,
        total: g.length,
        table: x(g),
        icon: R().createElement(hn(), {
          color: "primary",
          fontSize: "small"
        })
      }, {
        name: "Shopping",
        key: "shopping",
        blocked: (null === (r = y.filter(function (e) {
          return e.blocked;
        })) || void 0 === r ? void 0 : r.length) || 0,
        total: y.length,
        table: x(y),
        icon: R().createElement(yn(), {
          color: "primary",
          fontSize: "small"
        })
      }, {
        name: "Medical & Health",
        key: "health_and_medical",
        blocked: (null === (a = b.filter(function (e) {
          return e.blocked;
        })) || void 0 === a ? void 0 : a.length) || 0,
        total: b.length,
        table: x(b),
        icon: R().createElement(fn(), {
          color: "primary",
          fontSize: "small"
        })
      }, {
        name: "Travel & Entertainment",
        key: "travel_and_entertainment",
        blocked: (null === (i = E.filter(function (e) {
          return e.blocked;
        })) || void 0 === i ? void 0 : i.length) || 0,
        total: E.length,
        table: x(E),
        icon: R().createElement(un(), {
          color: "primary",
          fontSize: "small"
        })
      }];
    return R().createElement("div", null, k.map(function (e, t) {
      return R().createElement(vn(), {
        key: t
      }, R().createElement(kn(), {
        "aria-controls": "panel-".concat(t),
        color: "primary",
        expandIcon: R().createElement(ln(), null),
        id: "panel-".concat(t, "-header")
      }, R().createElement(Bt(), {
        alignItems: "center",
        container: !0,
        direction: "row"
      }, R().createElement(Bt(), {
        item: !0,
        mr: 2,
        xs: "auto"
      }, e.icon), R().createElement(Bt(), {
        container: !0,
        item: !0,
        xs: 8
      }, R().createElement(Bt(), {
        item: !0,
        md: "auto",
        xs: 12
      }, e.name), R().createElement(Bt(), {
        item: !0,
        md: "auto",
        xs: 12
      }, function (e) {
        return R().createElement(v(), {
          className: "rulesCount",
          sx: {
            color: ce.palette.grey[500],
            ml: {
              xs: 0,
              md: 2
            }
          }
        }, e.blocked, " blocked, ", e.total - e.blocked, " allowed");
      }(e))))), R().createElement(xn(), null, e.table));
    }));
  }
  function Gn() {
    return Gn = Object.assign ? Object.assign.bind() : function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];
        for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
      return e;
    }, Gn.apply(null, arguments);
  }
  function Yn(e) {
    var t = e.addBlockRules,
      n = e.blockRules,
      r = e.disabledSpendingSettings,
      a = e.spendingCategoryRules,
      i = e.readOnly,
      o = e.removeBlockRules,
      l = e.addCategoryRule,
      c = e.removeCategoryRule,
      u = R().createElement(Bt(), {
        alignItems: "center",
        columnSpacing: 2,
        container: !0
      }, a.map(function (e, t) {
        return R().createElement(Bt(), {
          className: "specific-rule-grid-item",
          item: !0,
          key: "spending-categories-item-".concat(t),
          md: 6,
          sm: 12
        }, (n = a[t], (0, wn.isEmpty)(n) ? R().createElement("div", null) : R().createElement(qt, Gn({
          disabled: n.allowedViaException || n.disableCategory,
          disabledTooltipText: n.allowedViaException ? "You've already allowed this category in the Top-line Protections section of your Spending Monitor" : "",
          hr: !1,
          is_checked: n.blocked,
          readOnly: i,
          updateChecked: function updateChecked() {
            return l(n);
          },
          updateUnChecked: function updateUnChecked() {
            return c(n);
          }
        }, n))));
        var n;
      }));
    return R().createElement("div", {
      style: {
        marginTop: "40px"
      }
    }, R().createElement(Q(), {
      variant: "h4"
    }, "Top Line Protections"), R().createElement("hr", {
      className: "title-table-hr"
    }), R().createElement(Vn, {
      addBlockRules: t,
      addCategoryRule: l,
      blockRules: n,
      disabledSpendingSettings: r,
      readOnly: i,
      removeBlockRules: o,
      spendingCategoryRules: a
    }), R().createElement("br", null), R().createElement("br", null), R().createElement(Q(), {
      variant: "h4"
    }, "All 35 Categories"), R().createElement("hr", {
      className: "title-table-hr"
    }), u);
  }
  function Kn(e) {
    return Kn = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
      return _typeof(e);
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
    }, Kn(e);
  }
  function Zn(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function Xn(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Zn(Object(n), !0).forEach(function (t) {
        Jn(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Zn(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  function Jn(e, t, n) {
    return (t = function (e) {
      var t = function (e, t) {
        if ("object" != Kn(e) || !e) return e;
        var n = e[Symbol.toPrimitive];
        if (void 0 !== n) {
          var r = n.call(e, "string");
          if ("object" != Kn(r)) return r;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(e);
      }(e);
      return "symbol" == Kn(t) ? t : t + "";
    }(t)) in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  function Qn(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
      if (null != n) {
        var r,
          a,
          i,
          o,
          l = [],
          c = !0,
          u = !1;
        try {
          if (i = (n = n.call(e)).next, 0 === t) {
            if (Object(n) !== n) return;
            c = !1;
          } else for (; !(c = (r = i.call(n)).done) && (l.push(r.value), l.length !== t); c = !0);
        } catch (e) {
          u = !0, a = e;
        } finally {
          try {
            if (!c && null != n.return && (o = n.return(), Object(o) !== o)) return;
          } finally {
            if (u) throw a;
          }
        }
        return l;
      }
    }(e, t) || function (e, t) {
      if (e) {
        if ("string" == typeof e) return er(e, t);
        var n = {}.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? er(e, t) : void 0;
      }
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function er(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  function tr(e) {
    var t = e.addBlockRules,
      n = e.axios,
      r = e.blockRules,
      a = e.disabledSpendingSettings,
      i = e.onChange,
      o = e.readOnly,
      l = e.removeBlockRules,
      c = e.ruleSetId,
      u = Qn((0, T.useState)(!0), 2),
      s = u[0],
      d = u[1],
      m = Qn((0, T.useState)([]), 2),
      f = m[0],
      p = m[1],
      h = "/api/v2/rulesets/".concat(c, "/semantic_categories"),
      g = (0, T.useCallback)(function () {
        n.get(h).then(function (e) {
          var t = e.data.data.map(function (e) {
            var t,
              n = {
                denylistSemantics: e.id
              };
            return null !== (t = e.attributes) && void 0 !== t && t.merchants[0] && (n.denylistMerchants = e.attributes.merchants[0]), {
              allowedViaException: e.attributes.allowedViaException,
              text: e.attributes.label,
              rules: n,
              detailText: e.attributes.description,
              tags: e.attributes.tags,
              blocked: e.attributes.blocked,
              id: e.id,
              disableCategory: null == a ? void 0 : a.includes(e.id)
            };
          });
          p(t);
        });
      }, [h]),
      y = function y(e, t, r) {
        var a = "/api/v2/rulesets/".concat(c, "/semantic_categories/").concat(e.id);
        n.patch(a, t).then(function () {
          g(), i && i(r);
        });
      },
      b = function b(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
          n = arguments.length > 2 ? arguments[2] : void 0,
          r = Lt(e, n ? "categoryException" : "category"),
          a = f.map(function (t) {
            return t.id === e.id ? Xn(Xn({}, t), {}, {
              blocked: !n
            }) : t;
          });
        p(a), y(e, {
          data: {
            attributes: n ? {
              allowedViaException: t
            } : {
              blocked: !0
            }
          }
        }, r);
      },
      E = function E(e) {
        var t = zt(e, "category"),
          n = f.map(function (t) {
            return t.id === e.id ? Xn(Xn({}, t), {}, {
              blocked: !1
            }) : t;
          });
        p(n), y(e, {
          data: {
            attributes: {
              blocked: !1
            }
          }
        }, t);
      };
    (0, T.useEffect)(function () {
      g();
    }, [g]);
    var S = function S() {
        d(function (e) {
          return !e;
        });
      },
      k = (v(), x(), R().createElement(Yn, {
        addBlockRules: t,
        addCategoryRule: b,
        blockRules: r,
        disabledSpendingSettings: a,
        readOnly: o,
        removeBlockRules: l,
        removeCategoryRule: E,
        spendingCategoryRules: f
      })),
      w = R().createElement($n, {
        addBlockRules: t,
        addCategoryRule: b,
        blockRules: r,
        disabledSpendingSettings: a,
        readOnly: o,
        removeBlockRules: l,
        removeCategoryRule: E,
        spendingCategoryRules: f
      });
    return R().createElement("div", {
      id: "spending-categories"
    }, R().createElement(We(), {
      alignItems: "flex-end",
      direction: "row",
      justifyContent: "space-between"
    }, R().createElement(Q(), {
      variant: "h3"
    }, "Spending Categories"), R().createElement(L(), {
      color: "tertiary",
      onClick: S,
      startIcon: s ? R().createElement(nn(), null) : R().createElement(en(), null),
      sx: {
        mb: -1,
        display: {
          xs: "none",
          sm: "flex"
        }
      }
    }, s ? "See All 35 Categories" : "See Category Groups")), R().createElement("hr", {
      className: "title-table-hr"
    }), R().createElement("div", null, s ? w : k), R().createElement(We(), {
      direction: "column",
      justifyContent: "center",
      sx: {
        display: {
          xs: "flex",
          sm: "none"
        }
      }
    }, R().createElement("hr", {
      style: {
        marginTop: "0px"
      }
    }), R().createElement(L(), {
      color: "tertiary",
      onClick: S,
      startIcon: s ? R().createElement(nn(), null) : R().createElement(en(), null),
      sx: {
        mb: -1
      }
    }, s ? "See All 35 Categories" : "See Category Groups")));
  }
  function nr(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
      if (null != n) {
        var r,
          a,
          i,
          o,
          l = [],
          c = !0,
          u = !1;
        try {
          if (i = (n = n.call(e)).next, 0 === t) {
            if (Object(n) !== n) return;
            c = !1;
          } else for (; !(c = (r = i.call(n)).done) && (l.push(r.value), l.length !== t); c = !0);
        } catch (e) {
          u = !0, a = e;
        } finally {
          try {
            if (!c && null != n.return && (o = n.return(), Object(o) !== o)) return;
          } finally {
            if (u) throw a;
          }
        }
        return l;
      }
    }(e, t) || function (e, t) {
      if (e) {
        if ("string" == typeof e) return rr(e, t);
        var n = {}.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? rr(e, t) : void 0;
      }
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function rr(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  function ar(e) {
    var t,
      n = e.spendingSettings,
      r = e.periods,
      a = e.remainingBudgetAmount,
      i = e.updateSettings,
      o = n.budget,
      l = !!o,
      c = (0, T.useRef)(null),
      u = nr((0, T.useState)(l ? null == o ? void 0 : o.limit.amount.toString() : "0"), 2),
      s = u[0],
      d = u[1],
      m = nr((0, T.useState)(l ? o.period : "daily"), 2),
      f = m[0],
      p = m[1],
      h = (0, T.useRef)(null),
      g = nr((0, T.useState)(l), 2),
      y = g[0],
      b = g[1];
    (0, T.useEffect)(function () {
      b(!!n.budget), d(function () {
        return l ? null == o ? void 0 : o.limit.amount.toString() : "0";
      });
    }, [n, o, l]);
    var E,
      x = function x() {
        y && (n.budget.limit.amount = Number(c.current.value) || 0, i(n, "budget"));
      },
      S = (0, T.useCallback)(function (e) {
        var t = e.target.value;
        p(t), y && (n.budget.period = t, i(n, "budget"));
      }, [i, n, y]),
      k = r.map(function (e) {
        return R().createElement("option", {
          key: e.value,
          value: e.value
        }, e.name);
      }),
      w = Number(null == o || null === (t = o.limit) || void 0 === t ? void 0 : t.amount) || 0,
      C = "".concat((E = f, r.find(function (e) {
        return e.value === E;
      }).name), " limit: $").concat(null == a ? void 0 : a.toFixed(2), " remains of $").concat(null == w ? void 0 : w.toFixed(2));
    return R().createElement("div", {
      className: "spending-budget",
      ref: h
    }, R().createElement(We(), {
      alignItems: "flex-start;",
      direction: {
        xs: "column",
        sm: "row"
      },
      spacing: 2
    }, R().createElement(v(), {
      sx: {
        display: "flex",
        alignItems: "center"
      }
    }, R().createElement(Bn, {
      checked: y,
      id: "spending-budget",
      label: "Set",
      onChange: function onChange() {
        y ? (b(!1), n.budget = null, i(n, "budget")) : (b(!0), n.budget = {
          period: f,
          limit: {
            amount: 0
          }
        }, i(n, "budget"));
      }
    })), R().createElement(v(), {
      sx: {
        display: "flex",
        alignItems: "center"
      }
    }, R().createElement("select", {
      "aria-label": "limit frequency",
      "data-testid": "budget-frequency",
      disabled: !y,
      id: "budget-frequency",
      onChange: S,
      value: f
    }, k), R().createElement(v(), {
      sx: {
        textAlign: "center"
      }
    }, "   limit of"), R().createElement(In, {
      disabled: !y,
      label: "Input Amount",
      onBlur: x,
      onEnter: x,
      ref: c,
      textfieldValue: s
    }), R().createElement(v(), {
      sx: {
        ml: 1,
        display: "flex",
        alignItems: "center"
      }
    }, R().createElement(Tt, {
      detailText: "Set a daily, weekly, or monthly limit on spending"
    })))), f && a >= 0 && "0" !== s && R().createElement(Q(), {
      id: "budget-summary",
      sx: {
        marginTop: "15px",
        color: "#828282"
      },
      variant: "body2"
    }, C));
  }
  Dn.propTypes = {
    onConfirm: re().func.isRequired,
    onCancel: re().func.isRequired,
    rule: re().object.isRequired
  }, Wn.propTypes = {
    spendingCategoryRules: re().array.isRequired,
    addCategoryRule: re().func.isRequired,
    readOnly: re().bool,
    hidden: re().bool.isRequired
  }, Vn.propTypes = {
    blockRules: re().object.isRequired,
    disabledSpendingSettings: re().array,
    spendingCategoryRules: re().array.isRequired,
    addBlockRules: re().func,
    addCategoryRule: re().func,
    readOnly: re().bool,
    removeBlockRules: re().func
  }, $n.propTypes = {
    blockRules: re().object.isRequired,
    addBlockRules: re().func.isRequired,
    disabledSpendingSettings: re().array,
    spendingCategoryRules: re().array.isRequired,
    removeBlockRules: re().func.isRequired,
    readOnly: re().bool,
    addCategoryRule: re().func.isRequired,
    removeCategoryRule: re().func.isRequired
  }, Yn.propTypes = {
    blockRules: re().object.isRequired,
    addBlockRules: re().func.isRequired,
    disabledSpendingSettings: re().array,
    spendingCategoryRules: re().array.isRequired,
    removeBlockRules: re().func.isRequired,
    readOnly: re().bool,
    addCategoryRule: re().func.isRequired,
    removeCategoryRule: re().func.isRequired
  }, tr.propTypes = {
    addBlockRules: re().func.isRequired,
    axios: re().func.isRequired,
    blockRules: re().object.isRequired,
    onChange: re().func,
    readOnly: re().bool,
    disabledSpendingSettings: re().array,
    ruleSetId: re().string.isRequired,
    removeBlockRules: re().func.isRequired
  }, ar.propTypes = {
    updateSettings: re().func.isRequired,
    spendingSettings: re().object.isRequired,
    periods: re().array.isRequired,
    remainingBudgetAmount: re().number
  }, ar.defaultProps = {
    periods: [{
      name: "Daily",
      value: "daily"
    }, {
      name: "Weekly",
      value: "weekly"
    }, {
      name: "Monthly",
      value: "monthly"
    }]
  };
  var ir = ar,
    or = function or(e, t) {
      return te().tz(e, "h:mm A", t).utc().format("HH:mm");
    },
    lr = function lr(e, t) {
      return te().tz(e, "HH:mm", t).clone().tz(te().tz.guess()).format("h:mm A");
    },
    cr = function cr() {
      for (var e, t, n = 0, r = {}; n < 24;) t = n < 12 ? " AM" : " PM", r[e = "".concat(n % 12 == 0 ? 12 : n % 12, ":00").concat(t)] = 0 === n ? "Midnight" : 12 === n ? "Noon" : e, n++;
      return r;
    },
    ur = {
      start: "11:00 PM",
      end: "6:00 AM",
      timeZone: "Etc/UTC"
    };
  function sr(e) {
    var t = e.confirmText,
      n = e.contentText,
      r = e.onCancel,
      a = e.onConfirm,
      i = e.title;
    return R().createElement(ve(), {
      maxWidth: "sm",
      open: !0
    }, R().createElement(Ce(), null, i), R().createElement(ke(), null, R().createElement(zn(), null, n)), R().createElement(xe(), null, R().createElement(L(), {
      onClick: r,
      variant: "outlined"
    }, "Cancel"), R().createElement(L(), {
      onClick: a,
      variant: "contained"
    }, t)));
  }
  function dr(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
      if (null != n) {
        var r,
          a,
          i,
          o,
          l = [],
          c = !0,
          u = !1;
        try {
          if (i = (n = n.call(e)).next, 0 === t) {
            if (Object(n) !== n) return;
            c = !1;
          } else for (; !(c = (r = i.call(n)).done) && (l.push(r.value), l.length !== t); c = !0);
        } catch (e) {
          u = !0, a = e;
        } finally {
          try {
            if (!c && null != n.return && (o = n.return(), Object(o) !== o)) return;
          } finally {
            if (u) throw a;
          }
        }
        return l;
      }
    }(e, t) || function (e, t) {
      if (e) {
        if ("string" == typeof e) return mr(e, t);
        var n = {}.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? mr(e, t) : void 0;
      }
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function mr(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  function fr(e) {
    var t = e.curfewSettings,
      n = e.spendingSettings,
      r = e.readOnly,
      a = e.updateSettings,
      i = (0, T.useRef)(),
      o = new Date(),
      l = te()(o),
      c = te().tz.guess(l),
      u = te().tz(c).zoneAbbr(),
      s = cr(),
      d = dr((0, T.useState)(null), 2),
      m = d[0],
      f = d[1],
      p = dr((0, T.useState)(s[ur.start]), 2),
      h = p[0],
      g = p[1],
      y = dr((0, T.useState)(s[ur.end]), 2),
      b = y[0],
      E = y[1],
      x = dr((0, T.useState)(!!t), 2),
      S = x[0],
      k = x[1];
    (0, T.useEffect)(function () {
      if (t) {
        var e = lr(t.start, t.timeZone),
          n = lr(t.end, t.timeZone);
        g(e), E(n);
      }
      k(!!t);
    }, [t]);
    var w = (0, T.useCallback)(function (e) {
        var t = e.target.value;
        if (g(t), S && n.curfew) {
          var r = or(t, c);
          n.curfew.start = r, a(n, "curfew");
        }
      }, [S, n, c, a]),
      C = (0, T.useCallback)(function (e) {
        var t = e.target.value;
        if (E(t), S && n.curfew) {
          var r = or(t, c);
          n.curfew.end = r, a(n, "curfew");
        }
      }, [S, n, c, a]),
      O = (0, T.useCallback)(function () {
        k(!0), n.curfew = ur, a(n, "curfew");
      }, [n, a]),
      A = (0, T.useCallback)(function () {
        k(!1), n.curfew = null, a(n, "curfew");
      }, [a]),
      j = (0, T.useCallback)(function () {
        f(null);
      }, []),
      _ = (0, T.useCallback)(function () {
        f(S ? {
          message: "Are you sure you want to remove the curfew on this card?",
          actionText: "Remove Curfew",
          handleSubmit: function handleSubmit() {
            k(!1), A(), j();
          }
        } : {
          message: "During these hours all transactions on the card will be blocked, including emergency medical services. Please confirm that you are certain you'd like to set a curfew on this card.",
          actionText: "Set Curfew",
          handleSubmit: function handleSubmit() {
            k(!0), O(), j();
          }
        });
      }, [S, A, O, j]),
      q = Object.keys(s).map(function (e) {
        if (Object.prototype.hasOwnProperty.call(s, e)) return R().createElement("option", {
          key: s[e],
          value: e
        }, s[e]);
      });
    return r ? R().createElement("div", null, R().createElement(Q(), {
      variant: "body1"
    }, S ? R().createElement(R().Fragment, null, "Transactions are blocked from ", R().createElement("b", null, te()(h, "HH").format("h:mm A")), " to", " ", R().createElement("b", null, te()(b, "HH").format("h:mm A")), ". Note that these times are displayed in ", R().createElement("b", null, u), ".") : "Curfew is not set"), R().createElement("hr", null)) : R().createElement("div", null, R().createElement("div", {
      className: "spending-curfew",
      ref: i
    }, R().createElement("label", {
      className: "checkbox_label"
    }, R().createElement(We(), {
      alignItems: "flex-start;",
      direction: {
        xs: "column",
        sm: "row"
      },
      spacing: 2
    }, R().createElement(v(), {
      sx: {
        display: "flex",
        alignItems: "center"
      }
    }, R().createElement(Bn, {
      checked: S,
      id: "spending-curfew",
      label: "Curfew",
      onChange: _
    }), R().createElement(v(), {
      sx: {
        ml: -1,
        mr: 5,
        display: "flex",
        alignItems: "center"
      }
    }, R().createElement(Tt, {
      detailText: "Set daily time limits on when transactions can occur"
    }))), R().createElement(v(), {
      sx: {
        ml: "0 !important"
      }
    }, R().createElement("select", {
      onChange: w,
      value: h
    }, q), "  to  ", R().createElement("select", {
      onChange: C,
      value: b
    }, q)))), R().createElement("div", {
      className: "timezone-note",
      style: {
        marginTop: 16,
        color: "#828282"
      }
    }, R().createElement("small", null, "Note: These times are displayed in ", u)), m && R().createElement(sr, {
      confirmText: m.actionText,
      contentText: m.message,
      onCancel: j,
      onConfirm: m.handleSubmit,
      title: "Are you sure?"
    })));
  }
  function pr(e) {
    var t,
      n,
      r,
      a,
      i,
      o = e.blockRules,
      l = e.curfewSettings,
      c = e.disableCashAccess,
      u = e.spendingSettings,
      s = e.addBlockRules,
      d = e.readOnly,
      m = e.removeBlockRules,
      f = e.remainingBudgetAmount,
      p = e.showBudgetSettings,
      h = e.showCurfewSettings,
      g = e.updateSettings;
    return void 0 === o.maxTransactionSizeCash || null === o.maxTransactionSizeCash ? (t = "0", n = !1) : (t = o.maxTransactionSizeCash.toString(), n = !0), void 0 === o.maxTransactionSize || null === o.maxTransactionSize ? (r = "0", a = !1) : (r = o.maxTransactionSize.toString(), a = !0), d ? R().createElement("div", null, R().createElement(Q(), {
      variant: "h2"
    }, "Spending Limits"), R().createElement("hr", {
      className: "title-hr"
    }), R().createElement(Q(), {
      variant: "body1"
    }, n ? R().createElement(R().Fragment, null, "Your cash withdrawal limit is", " ", R().createElement("span", {
      style: {
        fontWeight: "bold"
      }
    }, "$", t)) : "Cash withdrawal limit is not set"), R().createElement("hr", null), R().createElement(Q(), {
      variant: "body1"
    }, a ? R().createElement(R().Fragment, null, "Transactions over ", R().createElement("span", {
      style: {
        fontWeight: "bold"
      }
    }, "$", r), " will be blocked") : "Transaction limit is not set"), R().createElement("hr", null), p && (null == u ? void 0 : u.budget) && R().createElement(R().Fragment, null, R().createElement(Q(), {
      variant: "body1"
    }, "Your spending limit is set to ", R().createElement("b", null, "$", null === (i = u.budget.limit) || void 0 === i ? void 0 : i.amount), " ", u.budget.period, ". It resets", " ", {
      daily: "daily",
      weekly: "every Sunday morning",
      monthly: "on the 1st of every month"
    }[u.budget.period], " at", " ", R().createElement("b", null, "02:00 AM Pacific / 05:00AM Eastern.")), R().createElement("hr", null)), h && R().createElement(fr, {
      curfewSettings: l,
      readOnly: !0,
      spendingSettings: u,
      updateSettings: g
    })) : R().createElement("div", null, R().createElement(Q(), {
      variant: "h2"
    }, "Spending Limits"), R().createElement("hr", {
      className: "title-hr"
    }), R().createElement(Pn, {
      detailText: "Limits how much cash can be withdrawn per transaction",
      disabled: c,
      id: "cash-withdrawal-limit",
      isChecked: n,
      name: "maxTransactionSizeCash",
      text: "Cash Withdrawal Limit   ",
      textfield: t,
      updateChecked: s,
      updateUnChecked: m
    }), R().createElement(Pn, {
      detailText: "Set a maximum purchase amount per transaction",
      id: "transaction-limit",
      isChecked: a,
      name: "maxTransactionSize",
      text: "Transaction Limit   ",
      textfield: r,
      updateChecked: s,
      updateUnChecked: m
    }), p && u && R().createElement(ir, {
      remainingBudgetAmount: f,
      spendingSettings: u,
      updateSettings: g
    }), h && p && R().createElement("hr", null), h && R().createElement(fr, {
      curfewSettings: l,
      readOnly: d,
      spendingSettings: u,
      updateSettings: g
    }));
  }
  sr.propTypes = {
    confirmText: re().string.isRequired,
    contentText: re().string.isRequired,
    onCancel: re().func.isRequired,
    onConfirm: re().func.isRequired,
    title: re().string.isRequired
  }, fr.propTypes = {
    updateSettings: re().func.isRequired,
    curfewSettings: re().object,
    spendingSettings: re().object,
    readOnly: re().bool
  }, pr.propTypes = {
    blockRules: re().object.isRequired,
    spendingSettings: re().object,
    addBlockRules: re().func.isRequired,
    readOnly: re().bool,
    removeBlockRules: re().func.isRequired,
    showBudgetSettings: re().bool,
    disableCashAccess: re().bool,
    remainingBudgetAmount: re().number,
    updateSettings: re().func
  };
  var hr = require("@mui/icons-material/Check"),
    gr = n.n(hr);
  function yr(e) {
    var t = e.allowAll,
      n = e.onConfirm,
      r = e.onCancel;
    return R().createElement(ve(), {
      maxWidth: "md",
      open: !0
    }, R().createElement(Ce(), null, t ? "Are you sure you want to allow all transactions, including access to cash?" : "Are you sure you want to block all transactions?"), R().createElement(ke(), null, R().createElement(zn(), null, t ? "This overrides all spending settings and immediately allows the cardholder to complete any purchases less than or equal to the balance on the card, including access to cash." : "This overrides all spending settings and immediately blocks the cardholder from making any purchases."), R().createElement("br", null), R().createElement(zn(), null, "You must manually remove the override to allow purchases and restore your custom spending settings. ")), R().createElement(xe(), null, R().createElement(L(), {
      color: "secondary",
      onClick: r,
      variant: "outlined"
    }, "Cancel"), R().createElement(L(), {
      color: "secondary",
      onClick: n,
      variant: "contained"
    }, "Confirm")));
  }
  yr.propTypes = {
    onConfirm: re().func.isRequired,
    allowAll: re().bool.isRequired,
    onCancel: re().func.isRequired
  };
  var br = require("@mui/icons-material/BlockRounded"),
    vr = n.n(br);
  function Er(e) {
    var t = e.allowOverrideEnabled,
      n = e.programName,
      r = e.readOnly,
      a = e.removeBlockRules,
      i = "temporaryOverrides",
      o = "Your spend settings are currently overridden.",
      l = "Contact the person who manages your card if you have questions.",
      c = r ? "".concat(o, " This ").concat(n, " is allowed to make all purchases, including access to cash. ").concat(l) : "".concat(o, " This ").concat(n, " can be used to make any purchases within the card balance, including\n        access to cash. Remove the override to restore your custom spending settings."),
      u = r ? "".concat(o, " This ").concat(n, " cannot be used to make purchases. ").concat(l) : "".concat(o, " This ").concat(n, " cannot be used to make any purchases. Remove the override to restore\n        your custom spending settings."),
      s = R().createElement("div", {
        id: "allow-all-banner"
      }, R().createElement("div", {
        style: {
          fontWeight: "bold",
          paddingBottom: 10
        }
      }, "All Transactions Allowed, Including Access to Cash"), R().createElement("div", null, c)),
      d = R().createElement("div", {
        id: "remove-all-banner"
      }, R().createElement("div", {
        style: {
          fontWeight: "bold",
          paddingBottom: 10
        }
      }, "All Transactions Blocked"), R().createElement("div", null, u)),
      m = R().createElement(L(), {
        className: "outlinedBlueButton",
        id: "remove-override-btn",
        onClick: t ? function () {
          a({
            allowAllTransactions: !0
          }, i);
        } : function () {
          a({
            blockAllTransactions: !0
          }, i);
        },
        sx: {
          bgcolor: "banner.contrast",
          color: "banner.main",
          width: {
            xs: "100%",
            sm: "auto"
          },
          whiteSpace: "nowrap",
          minWidth: "200px"
        },
        variant: "contained"
      }, "Remove Override");
    return R().createElement(v(), {
      sx: {
        p: "20px",
        borderRadius: 1,
        bgcolor: "banner.main",
        color: "banner.contrast"
      }
    }, R().createElement(We(), {
      alignItems: "center",
      direction: {
        xs: "column",
        sm: "row"
      },
      spacing: 3
    }, t ? R().createElement(gr(), null) : R().createElement(vr(), null), t ? s : d, !r && m));
  }
  Er.propTypes = {
    allowOverrideEnabled: re().bool.isRequired,
    programName: re().string,
    readOnly: re().bool,
    removeBlockRules: re().func.isRequired
  };
  var xr = Er;
  function Sr(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
      if (null != n) {
        var r,
          a,
          i,
          o,
          l = [],
          c = !0,
          u = !1;
        try {
          if (i = (n = n.call(e)).next, 0 === t) {
            if (Object(n) !== n) return;
            c = !1;
          } else for (; !(c = (r = i.call(n)).done) && (l.push(r.value), l.length !== t); c = !0);
        } catch (e) {
          u = !0, a = e;
        } finally {
          try {
            if (!c && null != n.return && (o = n.return(), Object(o) !== o)) return;
          } finally {
            if (u) throw a;
          }
        }
        return l;
      }
    }(e, t) || function (e, t) {
      if (e) {
        if ("string" == typeof e) return kr(e, t);
        var n = {}.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? kr(e, t) : void 0;
      }
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function kr(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  function wr(e) {
    var t = e.blockRules,
      n = e.addBlockRules,
      r = e.programName,
      a = void 0 === r ? "card" : r,
      i = e.readOnly,
      o = e.removeBlockRules,
      l = !!t.allowAllTransactions || !!t.blockAllTransactions,
      c = Sr((0, T.useState)(!1), 2),
      u = c[0],
      s = c[1],
      d = Sr((0, T.useState)({}), 2),
      m = d[0],
      f = d[1],
      p = function p(e) {
        f(e), s(!0);
      };
    return i ? R().createElement(R().Fragment, null, l && R().createElement(xr, {
      allowOverrideEnabled: !!t.allowAllTransactions,
      programName: a,
      readOnly: !0,
      removeBlockRules: o
    }), R().createElement(Q(), {
      sx: {
        maxWidth: "630px"
      },
      variant: "body1"
    }, "These are the settings on your card. \n    The card only works for purchases set to Allow. \n    To change the settings on your card, talk to the person who manages your card.")) : R().createElement("div", null, R().createElement(Q(), {
      variant: "h2"
    }, "Temporary Overrides"), R().createElement("hr", {
      className: "title-hr"
    }), l && R().createElement(xr, {
      allowOverrideEnabled: !!t.allowAllTransactions,
      programName: a,
      removeBlockRules: o
    }), !l && R().createElement(We(), {
      spacing: 2
    }, R().createElement(We(), {
      alignItems: "center",
      direction: {
        xs: "column",
        sm: "row"
      },
      spacing: 2
    }, R().createElement(L(), {
      color: "secondary",
      id: " block-all",
      onClick: function onClick() {
        return p("blockAllTransactions");
      },
      startIcon: R().createElement(an(), {
        color: "alert"
      }),
      sx: {
        width: {
          xs: "100%",
          sm: "initial"
        }
      },
      variant: "outlined"
    }, "Block All Transactions"), R().createElement("div", null, "Temporarily block all transactions with this override.")), R().createElement(We(), {
      alignItems: "center",
      direction: {
        xs: "column",
        sm: "row"
      },
      spacing: 2
    }, R().createElement(L(), {
      color: "secondary",
      id: "allow-all",
      onClick: function onClick() {
        return p("allowAllTransactions");
      },
      startIcon: R().createElement(gr(), {
        color: "primary"
      }),
      sx: {
        width: {
          xs: "100%",
          sm: "initial"
        }
      },
      variant: "outlined"
    }, "Allow All Transactions"), R().createElement("div", null, "Temporarily allow all transactions with this override. "))), u && R().createElement(yr, {
      allowAll: "allowAllTransactions" == m,
      onCancel: function onCancel() {
        s(!1);
      },
      onConfirm: function onConfirm() {
        n("allowAllTransactions" == m ? {
          allowAllTransactions: !0
        } : {
          blockAllTransactions: !0
        }, "temporaryOverrides"), s(!1), f({});
      }
    }));
  }
  function Cr(e) {
    return Cr = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
      return _typeof(e);
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
    }, Cr(e);
  }
  function Or(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function Ar(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Or(Object(n), !0).forEach(function (t) {
        Tr(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Or(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  function Tr(e, t, n) {
    return (t = function (e) {
      var t = function (e, t) {
        if ("object" != Cr(e) || !e) return e;
        var n = e[Symbol.toPrimitive];
        if (void 0 !== n) {
          var r = n.call(e, "string");
          if ("object" != Cr(r)) return r;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(e);
      }(e);
      return "symbol" == Cr(t) ? t : t + "";
    }(t)) in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  wr.propTypes = {
    addBlockRules: re().func.isRequired,
    blockRules: re().object.isRequired,
    readOnly: re().bool,
    removeBlockRules: re().func.isRequired
  };
  var Rr = ["blockAllTransactions", "allowAllTransactions", "blockScamWatch", "blockInternationalTransactions", "blockCardNotPresent", "blockATM", "blockSignatureCash", "blockPOSCash"],
    jr = ["maxTransactionSizeCash", "maxTransactionSize"],
    _r = ["allowlistMIDs", "allowlistMCCs", "allowlistPOSCodes", "allowlistMTIs", "allowlistMerchantNames", "allowlistSemantics", "allowlistMerchantClusters", "allowlistMerchants", "denylistMIDs", "denylistMCCs", "denylistPOSCodes", "denylistMTIs", "denylistMerchantNames", "denylistSemantics", "denylistMerchantClusters", "denylistMerchants"];
  function qr(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
      if (null != n) {
        var r,
          a,
          i,
          o,
          l = [],
          c = !0,
          u = !1;
        try {
          if (i = (n = n.call(e)).next, 0 === t) {
            if (Object(n) !== n) return;
            c = !1;
          } else for (; !(c = (r = i.call(n)).done) && (l.push(r.value), l.length !== t); c = !0);
        } catch (e) {
          u = !0, a = e;
        } finally {
          try {
            if (!c && null != n.return && (o = n.return(), Object(o) !== o)) return;
          } finally {
            if (u) throw a;
          }
        }
        return l;
      }
    }(e, t) || function (e, t) {
      if (e) {
        if ("string" == typeof e) return Ir(e, t);
        var n = {}.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Ir(e, t) : void 0;
      }
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function Ir(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  function Mr(e) {
    var t = e.axios,
      n = e.disableCashAccess,
      r = e.disabledSpendingSettings,
      a = e.onChange,
      i = e.readOnly,
      o = e.ruleSetId,
      l = e.showAddMerchantButton,
      c = e.visibilityConfig,
      u = qr((0, T.useState)(null), 2),
      s = u[0],
      d = u[1],
      m = qr((0, T.useState)(null), 2),
      f = m[0],
      p = m[1],
      h = qr((0, T.useState)(null), 2),
      g = h[0],
      y = h[1],
      b = qr((0, T.useState)([]), 2),
      v = b[0],
      E = b[1],
      x = qr((0, T.useState)(null), 2),
      S = x[0],
      k = x[1],
      w = qr((0, T.useState)(!1), 2),
      C = w[0],
      O = w[1],
      A = qr((0, T.useState)(!0), 2),
      j = A[0],
      _ = A[1],
      q = qr((0, T.useState)(!0), 2),
      I = q[0],
      M = q[1],
      B = qr((0, T.useState)(!0), 2),
      N = B[0],
      P = B[1],
      L = qr((0, T.useState)(!0), 2),
      z = L[0],
      D = L[1],
      F = qr((0, T.useState)(!0), 2),
      U = F[0],
      W = F[1],
      V = qr((0, T.useState)(!0), 2),
      H = V[0],
      $ = V[1],
      G = qr((0, T.useState)(!0), 2),
      Y = G[0],
      K = G[1],
      Z = "/api/v2/rulesets/".concat(o),
      X = "/api/v2/spending_settings/".concat(o),
      J = (0, T.useCallback)(function () {
        t.get(Z).then(function (e) {
          var t = e.data;
          d(t.data.attributes.blockRules);
        });
      }, [Z]),
      ee = (0, T.useCallback)(function () {
        t.get(X, {
          params: {
            "fields[spending_settings.analysis]": "remainingBudget",
            include: "merchantExceptions"
          }
        }).then(function (e) {
          var t,
            n,
            r,
            a,
            i = e.data;
          p(i.data.attributes), null !== (t = i.data.meta) && void 0 !== t && t.remainingBudget && k(null === (r = i.data.meta) || void 0 === r || null === (r = r.remainingBudget) || void 0 === r ? void 0 : r.amount), null !== (n = i.data.attributes) && void 0 !== n && n.curfew && y(null === (a = i.data.attributes) || void 0 === a ? void 0 : a.curfew), i && E(i.included || []);
        });
      }, [X]);
    (0, T.useEffect)(function () {
      J(), ee();
    }, [J, ee]), (0, T.useEffect)(function () {
      c && (_(c.cashAccess), M(c.spendingCategories), P(c.spendingLimits), D(c.temporaryOverrides), W(c.merchantSettings), $(c.budgetSettings), K(c.curfewSettings));
    }, [c]);
    var te = function te(e) {
        var t = s.allowAllTransactions || s.blockAllTransactions;
        !C && t && "temporaryOverridesChange" !== e.id && O(!0), a && a(e);
      },
      ne = function ne(e) {
        var n = {
          data: {
            type: "ruleset",
            attributes: {
              blockRules: e
            },
            id: o
          }
        };
        t.patch(Z, n).then(function (e) {
          e.data, J();
        });
      },
      re = function re(e, t) {
        var n,
          r,
          a = Lt(e, t),
          i = (n = e, r = Ar({}, s), Object.keys(n).forEach(function (e) {
            var t = n[e];
            if (Rr.includes(e)) r[e] = t;else if (jr.includes(e)) r[e] = t;else if (_r.includes(e)) {
              var a = r[e] || [],
                i = t.split(";");
              if (r[e] = a.concat(i), e.includes("allowlist") || e.includes("denylist")) {
                var o = e.replace(/(allowlist|denylist)/g, function (e) {
                    return "denylist" === e ? "allowlist" : "denylist";
                  }),
                  l = r[o] || [];
                r[o] = l.filter(function (e) {
                  return !i.includes(e);
                });
              }
            }
          }), r);
        te(a), d(i), d(i), ne(i);
      },
      ae = function ae(e, t) {
        var n,
          r,
          a = zt(e, t),
          i = (n = e, r = Ar({}, s), Object.keys(n).forEach(function (e) {
            var t = n[e];
            if (Rr.includes(e)) r[e] = !1;else if (jr.includes(e)) r[e] = null;else if (_r.includes(e)) {
              var a = r[e] || [],
                i = t.split(";"),
                o = a.filter(function (e) {
                  return !i.includes(e);
                });
              o.length > 0 ? r[e] = o : delete r[e];
            }
          }), r);
        te(a), d(i), ne(i);
      },
      ie = R().createElement(Et(), {
        "aria-label": "close",
        color: "inherit",
        onClick: function onClick() {
          return O(!1);
        },
        size: "small"
      }, R().createElement(bt(), {
        fontSize: "small"
      })),
      oe = R().createElement(St(), {
        action: ie,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right"
        },
        autoHideDuration: 5e3,
        message: "Changes will go into effect when your Temporary Override is removed",
        onClose: function onClose() {
          return O(!1);
        },
        open: C
      });
    return R().createElement("div", {
      className: "SpendingSettings"
    }, R().createElement(Q(), {
      variant: "h1"
    }, "Spending Settings"), s && R().createElement(R().Fragment, null, z && R().createElement(wr, {
      addBlockRules: re,
      blockRules: s,
      readOnly: i,
      removeBlockRules: ae
    }), j && R().createElement(It, {
      addBlockRules: re,
      blockRules: s,
      disableCashAccess: n,
      readOnly: i,
      removeBlockRules: ae
    }), N && R().createElement(pr, {
      addBlockRules: re,
      blockRules: s,
      curfewSettings: g,
      disableCashAccess: n,
      readOnly: i,
      remainingBudgetAmount: S,
      removeBlockRules: ae,
      showBudgetSettings: H,
      showCurfewSettings: Y,
      spendingSettings: f,
      updateSettings: function updateSettings(e, n) {
        var r = Lt(e, n);
        te(r);
        var a = {
          data: {
            id: o,
            type: "spending_settings",
            attributes: e
          }
        };
        t.patch(X, a).then(function () {
          ee();
        });
      }
    }), U && R().createElement(Jt, {
      axios: t,
      fetchSpendingSetting: ee,
      merchantExceptions: v,
      onChange: te,
      readOnly: i,
      ruleSetId: o,
      showAddMerchantButton: l
    }), I && R().createElement(tr, {
      addBlockRules: re,
      axios: t,
      blockRules: s,
      disabledSpendingSettings: r,
      onChange: te,
      readOnly: i,
      removeBlockRules: ae,
      ruleSetId: o
    })), oe);
  }
  function Br(e) {
    return Br = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
      return _typeof(e);
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
    }, Br(e);
  }
  function Nr() {
    Nr = function Nr() {
      return t;
    };
    var e,
      t = {},
      n = Object.prototype,
      r = n.hasOwnProperty,
      a = Object.defineProperty || function (e, t, n) {
        e[t] = n.value;
      },
      i = "function" == typeof Symbol ? Symbol : {},
      o = i.iterator || "@@iterator",
      l = i.asyncIterator || "@@asyncIterator",
      c = i.toStringTag || "@@toStringTag";
    function u(e, t, n) {
      return Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), e[t];
    }
    try {
      u({}, "");
    } catch (e) {
      u = function u(e, t, n) {
        return e[t] = n;
      };
    }
    function s(e, t, n, r) {
      var i = t && t.prototype instanceof y ? t : y,
        o = Object.create(i.prototype),
        l = new j(r || []);
      return a(o, "_invoke", {
        value: O(e, n, l)
      }), o;
    }
    function d(e, t, n) {
      try {
        return {
          type: "normal",
          arg: e.call(t, n)
        };
      } catch (e) {
        return {
          type: "throw",
          arg: e
        };
      }
    }
    t.wrap = s;
    var m = "suspendedStart",
      f = "suspendedYield",
      p = "executing",
      h = "completed",
      g = {};
    function y() {}
    function b() {}
    function v() {}
    var E = {};
    u(E, o, function () {
      return this;
    });
    var x = Object.getPrototypeOf,
      S = x && x(x(_([])));
    S && S !== n && r.call(S, o) && (E = S);
    var k = v.prototype = y.prototype = Object.create(E);
    function w(e) {
      ["next", "throw", "return"].forEach(function (t) {
        u(e, t, function (e) {
          return this._invoke(t, e);
        });
      });
    }
    function C(e, t) {
      function n(a, i, o, l) {
        var c = d(e[a], e, i);
        if ("throw" !== c.type) {
          var u = c.arg,
            s = u.value;
          return s && "object" == Br(s) && r.call(s, "__await") ? t.resolve(s.__await).then(function (e) {
            n("next", e, o, l);
          }, function (e) {
            n("throw", e, o, l);
          }) : t.resolve(s).then(function (e) {
            u.value = e, o(u);
          }, function (e) {
            return n("throw", e, o, l);
          });
        }
        l(c.arg);
      }
      var i;
      a(this, "_invoke", {
        value: function value(e, r) {
          function a() {
            return new t(function (t, a) {
              n(e, r, t, a);
            });
          }
          return i = i ? i.then(a, a) : a();
        }
      });
    }
    function O(t, n, r) {
      var a = m;
      return function (i, o) {
        if (a === p) throw Error("Generator is already running");
        if (a === h) {
          if ("throw" === i) throw o;
          return {
            value: e,
            done: !0
          };
        }
        for (r.method = i, r.arg = o;;) {
          var l = r.delegate;
          if (l) {
            var c = A(l, r);
            if (c) {
              if (c === g) continue;
              return c;
            }
          }
          if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
            if (a === m) throw a = h, r.arg;
            r.dispatchException(r.arg);
          } else "return" === r.method && r.abrupt("return", r.arg);
          a = p;
          var u = d(t, n, r);
          if ("normal" === u.type) {
            if (a = r.done ? h : f, u.arg === g) continue;
            return {
              value: u.arg,
              done: r.done
            };
          }
          "throw" === u.type && (a = h, r.method = "throw", r.arg = u.arg);
        }
      };
    }
    function A(t, n) {
      var r = n.method,
        a = t.iterator[r];
      if (a === e) return n.delegate = null, "throw" === r && t.iterator.return && (n.method = "return", n.arg = e, A(t, n), "throw" === n.method) || "return" !== r && (n.method = "throw", n.arg = new TypeError("The iterator does not provide a '" + r + "' method")), g;
      var i = d(a, t.iterator, n.arg);
      if ("throw" === i.type) return n.method = "throw", n.arg = i.arg, n.delegate = null, g;
      var o = i.arg;
      return o ? o.done ? (n[t.resultName] = o.value, n.next = t.nextLoc, "return" !== n.method && (n.method = "next", n.arg = e), n.delegate = null, g) : o : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, g);
    }
    function T(e) {
      var t = {
        tryLoc: e[0]
      };
      1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
    }
    function R(e) {
      var t = e.completion || {};
      t.type = "normal", delete t.arg, e.completion = t;
    }
    function j(e) {
      this.tryEntries = [{
        tryLoc: "root"
      }], e.forEach(T, this), this.reset(!0);
    }
    function _(t) {
      if (t || "" === t) {
        var n = t[o];
        if (n) return n.call(t);
        if ("function" == typeof t.next) return t;
        if (!isNaN(t.length)) {
          var a = -1,
            i = function n() {
              for (; ++a < t.length;) if (r.call(t, a)) return n.value = t[a], n.done = !1, n;
              return n.value = e, n.done = !0, n;
            };
          return i.next = i;
        }
      }
      throw new TypeError(Br(t) + " is not iterable");
    }
    return b.prototype = v, a(k, "constructor", {
      value: v,
      configurable: !0
    }), a(v, "constructor", {
      value: b,
      configurable: !0
    }), b.displayName = u(v, c, "GeneratorFunction"), t.isGeneratorFunction = function (e) {
      var t = "function" == typeof e && e.constructor;
      return !!t && (t === b || "GeneratorFunction" === (t.displayName || t.name));
    }, t.mark = function (e) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(e, v) : (e.__proto__ = v, u(e, c, "GeneratorFunction")), e.prototype = Object.create(k), e;
    }, t.awrap = function (e) {
      return {
        __await: e
      };
    }, w(C.prototype), u(C.prototype, l, function () {
      return this;
    }), t.AsyncIterator = C, t.async = function (e, n, r, a, i) {
      void 0 === i && (i = Promise);
      var o = new C(s(e, n, r, a), i);
      return t.isGeneratorFunction(n) ? o : o.next().then(function (e) {
        return e.done ? e.value : o.next();
      });
    }, w(k), u(k, c, "Generator"), u(k, o, function () {
      return this;
    }), u(k, "toString", function () {
      return "[object Generator]";
    }), t.keys = function (e) {
      var t = Object(e),
        n = [];
      for (var r in t) n.push(r);
      return n.reverse(), function e() {
        for (; n.length;) {
          var r = n.pop();
          if (r in t) return e.value = r, e.done = !1, e;
        }
        return e.done = !0, e;
      };
    }, t.values = _, j.prototype = {
      constructor: j,
      reset: function reset(t) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(R), !t) for (var n in this) "t" === n.charAt(0) && r.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = e);
      },
      stop: function stop() {
        this.done = !0;
        var e = this.tryEntries[0].completion;
        if ("throw" === e.type) throw e.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(t) {
        if (this.done) throw t;
        var n = this;
        function a(r, a) {
          return l.type = "throw", l.arg = t, n.next = r, a && (n.method = "next", n.arg = e), !!a;
        }
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var o = this.tryEntries[i],
            l = o.completion;
          if ("root" === o.tryLoc) return a("end");
          if (o.tryLoc <= this.prev) {
            var c = r.call(o, "catchLoc"),
              u = r.call(o, "finallyLoc");
            if (c && u) {
              if (this.prev < o.catchLoc) return a(o.catchLoc, !0);
              if (this.prev < o.finallyLoc) return a(o.finallyLoc);
            } else if (c) {
              if (this.prev < o.catchLoc) return a(o.catchLoc, !0);
            } else {
              if (!u) throw Error("try statement without catch or finally");
              if (this.prev < o.finallyLoc) return a(o.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(e, t) {
        for (var n = this.tryEntries.length - 1; n >= 0; --n) {
          var a = this.tryEntries[n];
          if (a.tryLoc <= this.prev && r.call(a, "finallyLoc") && this.prev < a.finallyLoc) {
            var i = a;
            break;
          }
        }
        i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
        var o = i ? i.completion : {};
        return o.type = e, o.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, g) : this.complete(o);
      },
      complete: function complete(e, t) {
        if ("throw" === e.type) throw e.arg;
        return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), g;
      },
      finish: function finish(e) {
        for (var t = this.tryEntries.length - 1; t >= 0; --t) {
          var n = this.tryEntries[t];
          if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), R(n), g;
        }
      },
      catch: function _catch(e) {
        for (var t = this.tryEntries.length - 1; t >= 0; --t) {
          var n = this.tryEntries[t];
          if (n.tryLoc === e) {
            var r = n.completion;
            if ("throw" === r.type) {
              var a = r.arg;
              R(n);
            }
            return a;
          }
        }
        throw Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(t, n, r) {
        return this.delegate = {
          iterator: _(t),
          resultName: n,
          nextLoc: r
        }, "next" === this.method && (this.arg = e), g;
      }
    }, t;
  }
  function Pr(e, t, n, r, a, i, o) {
    try {
      var l = e[i](o),
        c = l.value;
    } catch (e) {
      return void n(e);
    }
    l.done ? t(c) : Promise.resolve(c).then(r, a);
  }
  function Lr(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
      if (null != n) {
        var r,
          a,
          i,
          o,
          l = [],
          c = !0,
          u = !1;
        try {
          if (i = (n = n.call(e)).next, 0 === t) {
            if (Object(n) !== n) return;
            c = !1;
          } else for (; !(c = (r = i.call(n)).done) && (l.push(r.value), l.length !== t); c = !0);
        } catch (e) {
          u = !0, a = e;
        } finally {
          try {
            if (!c && null != n.return && (o = n.return(), Object(o) !== o)) return;
          } finally {
            if (u) throw a;
          }
        }
        return l;
      }
    }(e, t) || function (e, t) {
      if (e) {
        if ("string" == typeof e) return zr(e, t);
        var n = {}.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? zr(e, t) : void 0;
      }
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function zr(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  function Dr(e) {
    var t = e.baseUrl,
      n = e.code,
      r = e.codeVerifier,
      a = e.disabledSpendingSettings,
      i = e.disableCashAccess,
      o = e.onChange,
      l = e.readOnly,
      c = e.showAddMerchantButton,
      u = e.themeConfig,
      s = e.visibilityConfig,
      d = Lr((0, T.useState)(null), 2),
      m = d[0],
      f = d[1],
      p = Lr((0, T.useState)(!0), 2),
      h = p[0],
      g = p[1],
      y = Lr((0, T.useState)(null), 2),
      b = y[0],
      E = y[1],
      S = ue(u),
      C = "/api/v2/access_tokens";
    return (0, T.useEffect)(function () {
      var e = function () {
        var e,
          a = (e = Nr().mark(function e() {
            var a, i, o, l, c, u, s, d, m, p;
            return Nr().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.prev = 0, g(!0), o = {
                    code: n,
                    codeVerifier: r
                  }, e.next = 5, O().post(C, o);
                case 5:
                  if (l = e.sent, c = l.data.meta.token, O().defaults.baseURL = void 0 !== t ? t : "https://member.truelinkfinancial.com", O().defaults.headers.common.Authorization = "Bearer ".concat(c), O().defaults.headers.post["Content-Type"] = "application/json", u = (0, A.jwtDecode)(c), s = null == u || null === (a = u.account) || void 0 === a ? void 0 : a.id) {
                    e.next = 14;
                    break;
                  }
                  throw new Error("Account ID not found in token");
                case 14:
                  return d = "/api/v2/accounts/".concat(s), e.next = 17, O().get(d);
                case 17:
                  m = e.sent, p = null == m || null === (i = m.data.data.relationships) || void 0 === i ? void 0 : i.ruleset.data.id, f(p), e.next = 25;
                  break;
                case 22:
                  e.prev = 22, e.t0 = e.catch(0), E(e.t0);
                case 25:
                  return e.prev = 25, g(!1), e.finish(25);
                case 28:
                case "end":
                  return e.stop();
              }
            }, e, null, [[0, 22, 25, 28]]);
          }), function () {
            var t = this,
              n = arguments;
            return new Promise(function (r, a) {
              var i = e.apply(t, n);
              function o(e) {
                Pr(i, r, a, o, l, "next", e);
              }
              function l(e) {
                Pr(i, r, a, o, l, "throw", e);
              }
              o(void 0);
            });
          });
        return function () {
          return a.apply(this, arguments);
        };
      }();
      e();
    }, [C, t, n, r]), h ? R().createElement(v(), {
      sx: {
        textAlign: "center",
        height: 500
      }
    }, R().createElement(x(), {
      color: "success",
      sx: {
        m: 30
      }
    })) : b ? R().createElement(v(), {
      sx: {
        textAlign: "center",
        marginTop: 50,
        height: 200,
        color: "red"
      }
    }, R().createElement("p", null, "Error loading data: ", b.message)) : R().createElement(w.ThemeProvider, {
      theme: S
    }, R().createElement(k(), null), R().createElement(st, {
      theme: S
    }), R().createElement(Mr, {
      axios: O(),
      disableCashAccess: i,
      disabledSpendingSettings: a,
      onChange: o,
      readOnly: l,
      ruleSetId: m,
      showAddMerchantButton: c,
      visibilityConfig: s
    }));
  }
  var Fr = Dr,
    Ur = exports;
  for (var Wr in r) Ur[Wr] = r[Wr];
  r.__esModule && Object.defineProperty(Ur, "__esModule", {
    value: !0
  });
}();